/* push-deploy-20260526T152621Z */
/*! VijverCheck: Thin client v0.2.0 (Shopify section) */
(function () {
  'use strict';

  const CFG = Object.assign(
    {
      apiBaseUrl: 'https://rz2-vijverweer-2ioi34m33q-ez.a.run.app',
      apiAnonKey: '',
      ga4MeasurementId: '',
      gadsConversionId: '',
      klaviyoPublicKey: '',
      shopBaseUrl: window.location.origin,
      shopCurrency: 'EUR',
      shopLocale: 'nl',
      enableSelfTests: false,
      rulesVersionPin: null,
      requestTimeoutMs: 8000,
      defaultConsent: false,
      consentOverride: null
    },
    window.VIJVERWEER_CONFIG || {}
  );

  // ──────────────────────────────────────────────────────────────
  // UTILS
  // ──────────────────────────────────────────────────────────────
  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  // ── Resultaat-eerst: scroll naar de advies-cards na een succesvolle submit.
  //    Respecteert prefers-reduced-motion (WCAG 2.3.3 / Apple-stijl rust).
  //    Vervangt de twee voormalige inline scrollIntoView-calls (hardcoded smooth).
  function scrollToAdvies() {
    // Progressive disclosure (16-10-2026): het resultaat (#vw-results) staat nu
    // direct onder de startkaart, met de watertest als ingeklapte balk erin.
    // Scroll dus naar de kop van het resultaat. Fallback op de oude ankers.
    const res = $('#vw-results') || $('#vw-diagnose') || $('#vw-advies');
    if (!res || !res.scrollIntoView) return;
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try {
      res.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    } catch (_) {
      res.scrollIntoView();
    }
  }

  // ── Weergavestaat (progressive disclosure, 16-10-2026).
  //    start:  alleen de startkaart (postcode + diepte) en de informatieblokken;
  //            #vw-results blijft hidden, dus geen lege placeholders in beeld.
  //    advies: #vw-results zichtbaar (locatiebalk, weer, watertest ingeklapt,
  //            advieskaarten, producten). Gezet na de eerste geslaagde /advice.
  //    CSS: assets/vijvercheck.css ([data-vw-state] + .vw-only-start/.vw-only-advies).
  function vwSetState(state) {
    const root = document.querySelector('[data-vc="vijvercheck"]');
    if (root) root.setAttribute('data-vw-state', state === 'advies' ? 'advies' : 'start');
    const results = $('#vw-results');
    if (results) results.hidden = state !== 'advies';
  }

  // ── Diepte in Stap 1 (#vw-depth-quick) en de exacte diepte in Stap 2 (#vw-depth)
  //    blijven gelijk: een keuze in Stap 1 vult Stap 2 (en vuurt input/change,
  //    zodat de forecast-refetch en de localStorage-bewaring gewoon meelopen);
  //    typt iemand een exacte diepte, dan springt de keuzelijst naar de
  //    dichtstbijzijnde klasse. Teruggeven: de diepte die nu geldt, of null.
  function vwDepthQuick() {
    const sel = $('#vw-depth-quick');
    if (!sel) return null;
    const v = parseInt(sel.value, 10);
    return Number.isFinite(v) ? v : null;
  }
  function vwSyncDepthQuickFrom(depthCm) {
    const sel = $('#vw-depth-quick');
    if (!sel || !Number.isFinite(depthCm)) return;
    let best = null, bestDiff = Infinity;
    Array.prototype.forEach.call(sel.options, function (o) {
      const d = Math.abs(parseInt(o.value, 10) - depthCm);
      if (d < bestDiff) { bestDiff = d; best = o.value; }
    });
    if (best != null && sel.value !== best) sel.value = best;
  }

  // ── ScrollSpy voor de sticky anker-nav (#vw-anchor-nav). Markeert de
  //    zichtbare sectie via IntersectionObserver (IA2 / Nielsen H1 visibility).
  //    Lost eigenaar-pijn "ik raak de weg kwijt" op. Faalt stil zonder IO.
  function initScrollSpy() {
    const nav = $('#vw-anchor-nav');
    if (!nav || typeof IntersectionObserver === 'undefined') return;
    const links = $$('.vw-spy-link', nav);
    if (!links.length) return;
    const activeCls = ['text-navy', 'bg-koilight/40'];
    const idleCls = ['text-slate-600'];
    const setActive = (id) => {
      links.forEach(a => {
        const on = a.getAttribute('data-vw-spy') === id;
        a.setAttribute('aria-current', on ? 'true' : 'false');
        if (on) { a.classList.add(...activeCls); a.classList.remove(...idleCls); }
        else { a.classList.remove(...activeCls); a.classList.add(...idleCls); }
      });
    };
    const sections = links
      .map(a => document.getElementById(a.getAttribute('data-vw-spy')))
      .filter(Boolean);
    if (!sections.length) return;
    const io = new IntersectionObserver((entries) => {
      // Kies de bovenste sectie die momenteel zichtbaar is.
      const visible = entries
        .filter(e => e.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
      if (visible.length) setActive(visible[0].target.id);
    }, { rootMargin: '-20% 0px -65% 0px', threshold: 0 });
    sections.forEach(sec => io.observe(sec));
  }

  function uuidv7() {
    const t = Date.now();
    const hex = t.toString(16).padStart(12, '0');
    const rnd = crypto.getRandomValues(new Uint8Array(10));
    const b = Array.from(rnd, x => x.toString(16).padStart(2, '0'));
    return (
      hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-7' + b[0].slice(1) + b[1] +
      '-' + ((rnd[2] & 0x3f) | 0x80).toString(16) + b[3] +
      '-' + b[4] + b[5] + b[6] + b[7] + b[8] + b[9]
    );
  }

  function getOrCreateSessionId() {
    try {
      const KEY = 'vw_sid';
      let id = sessionStorage.getItem(KEY);
      if (!id) { id = uuidv7(); sessionStorage.setItem(KEY, id); }
      return id;
    } catch (_) { return 'anon-' + Math.random().toString(36).slice(2, 10); }
  }

  function preserveUtm(url) {
    try {
      const current = new URL(window.location.href);
      const u = new URL(url, window.location.origin);
      [
        'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
        'gclid', 'gbraid', 'wbraid', 'fbclid', '_gl', 'ttclid', 'msclkid'
      ].forEach(k => {
        if (current.searchParams.has(k)) u.searchParams.set(k, current.searchParams.get(k));
      });
      return u.toString();
    } catch (_) { return url; }
  }

  function formatDate(date, format) {
    if (format === 'weekday-short') {
      return new Date(date).toLocaleDateString('nl-NL', { weekday: 'short', month: 'numeric', day: 'numeric' });
    }
    return new Date(date).toLocaleDateString('nl-NL', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
  }

  // ──────────────────────────────────────────────────────────────
  // TRIGGER-LABEL HUMANIZER
  //
  // Backend-triggers zijn technische slugs (bv. `voorjaar_opruimen`,
  // `filamentous_algae`, `ammonia_spike`). Die mogen nooit in de UI
  // zichtbaar zijn, klanten zien developer-strings en raken
  // vertrouwen kwijt. Deze dictionary mapt de ~30 meest voorkomende
  // slugs naar Nederlandse labels (brandbook tone of voice: warm,
  // begrijpelijk, geen vakjargon zonder uitleg). Voor onbekende slugs
  // fallbackt humanizeTrigger naar: strip `app_` prefix, underscores
  // worden spaties, eerste letter hoofdletter.
  // ──────────────────────────────────────────────────────────────
  const TRIGGER_LABELS = Object.freeze({
    // Seizoen
    voorjaar_opruimen:          'Voorjaarsopruiming',
    voorjaar_opstart:           'Voorjaarsopstart',
    zomer_hitte:                'Zomer-hitte',
    zomer_beluchting:           'Beluchting bij hitte',
    najaar_bladval:             'Bladval in najaar',
    najaar_netten:              'Najaarsnetten plaatsen',
    winter_beluchting:          'Winter-beluchting',
    autumn_leaves:              'Bladval in najaar',
    autumn_nets:                'Najaarsnetten plaatsen',
    autumn_decline:             'Najaars-afbouw',
    breeding_season:            'Paaitijd',
    // Algen
    filamentous_algae:          'Draadalg',
    algae_bloom:                'Algenbloei',
    algae_fuel:                 'Voedingsstoffen voor algen',
    cyanobacteria_bloom:        'Blauwalg-bloei',
    duckweed_bloom:             'Kroos-explosie',
    draadalg:                   'Draadalg',
    draadalgen:                 'Draadalgen',
    augustus_blauwalgen:        'Blauwalg in augustus',
    app_draadalg:               'Draadalg',
    app_kroos:                  'Kroos',
    app_troebelheid:            'Troebel water',
    // Water-chemie
    ammonia_spike:              'Ammoniak-piek',
    ammonia_critical:           'Ammoniak kritisch',
    ammonia_spike_startup:      'Ammoniak bij filter-opstart',
    nitrite_spike:              'Nitriet-piek',
    chlorine_spike:             'Chloor-piek',
    ph_swing:                   'pH-schommeling',
    kh_depletion:               'KH te laag',
    oxygen_deficit:             'Zuurstoftekort',
    brown_water:                'Bruin water',
    // Biologie
    bacterial_bloom:            'Bacteriebloei',
    bacterien:                  'Bacterie-aanvulling',
    bacteriestarter:            'Bacteriestarter',
    bacterien_reseed:           'Bacteriën bijenten',
    // Visgezondheid
    anchor_worm:                'Ankerworm',
    fish_emergency:             'Vis-spoedgeval',
    buoyancy_disorder:          'Zwemblaasprobleem',
    bleeding:                   'Bloedende vis',
    dropsy:                     'Waterzucht',
    columnaris:                 'Columnaris',
    abdominal_swelling:         'Gezwollen buik',
    abnormal_coloration:        'Afwijkende kleur',
    // Filter & techniek
    filter_failure:             'Filterstoring',
    filter_capacity_loss:       'Filter-capaciteit verloren',
    filter_overdue_cleaning:    'Filterreiniging nodig',
    filter_restart_no_seeding:  'Filter opnieuw enten',
    carbon_aged:                'Actieve kool vervangen',
    clay_dosing_expired:        'Klei-dosering vernieuwen',
    beluchting:                 'Beluchting',
    circulatie:                 'Circulatie',
    // Algemeen
    balans:                     'Vijverbalans',
    diversiteit:                'Biodiversiteit',
    beschaduwing:               'Beschaduwing',
    druppeltest:                'Watertest-druppels',
    druppeltesten:              'Watertest-druppels',
    algenbestrijding:           'Algenbestrijding',
    filtermedia:                'Filtermedia',
    drukfilters:                'Drukfilters'
  });

  function humanizeTrigger(slug) {
    if (!slug || typeof slug !== 'string') return '';
    const s = slug.trim();
    // Exact match first
    if (TRIGGER_LABELS[s]) return TRIGGER_LABELS[s];
    // Strip common prefixes, then normalize
    const stripped = s.replace(/^app_/, '');
    if (TRIGGER_LABELS[stripped]) return TRIGGER_LABELS[stripped];
    // Fallback: underscore → spatie, eerste letter hoofdletter
    const spaced = stripped.replace(/_+/g, ' ').trim();
    return spaced.charAt(0).toUpperCase() + spaced.slice(1);
  }

  // ──────────────────────────────────────────────────────────────
  // COLLECTION-LABEL HUMANIZER
  //
  // Backend geeft in `response.data.collection_links[trigger]` een
  // lijst van {handle, url}, handle is de Shopify-collection-slug
  // (non-app_*, dus altijd klant-zichtbaar). Voor de "Bekijk ook"-
  // strook willen we:
  //   - een kort, catchy NL-label (nooit de ruwe handle "vijver-
  //     voorjaarsopstart" tonen; klanten lezen dat als bugs)
  //   - een 1-regelige subtitel zodat klant begrijpt wat erin zit
  //
  // Onbekende handles krijgen een humanized fallback (hyphens →
  // spaties + hoofdletter) en lege subtitle.
  // ──────────────────────────────────────────────────────────────
  const COLLECTION_LABELS = Object.freeze({
    'waterverbeteraars':              { title: 'Waterverbeteraars',          sub: 'pH-, KH- en GH-correctoren' },
    'watertests-meetapparatuur':      { title: 'Watertests & meetapparatuur', sub: 'Druppeltests, strips en digitale meters' },
    'waterkwaliteit-onderhoud':       { title: 'Waterkwaliteit & onderhoud', sub: 'Alles voor gezond vijverwater' },
    'water-testen-meten':             { title: 'Water testen & meten',       sub: 'Eerst meten, dan bijsturen' },
    'helder-vijverwater-krijgen':     { title: 'Helder water krijgen',       sub: 'Klaringsmiddelen en bezinkers' },
    'koivoer-basis':                  { title: 'Basisvoer & onderhoudsvoer', sub: 'Voer voor heel het jaar' },
    'koivoer-seizoen':                { title: 'Seizoensvoer',               sub: 'Voer afgestemd op watertemperatuur' },
    'vijverbacterien':                { title: 'Vijverbacteriën',            sub: 'Starters en onderhouds-bacteriën' },
    'vijverfilters-uvc':              { title: 'Vijverfilters & UV-C',       sub: 'Filters en UV-units' },
    'vijverpompen':                   { title: 'Vijverpompen',               sub: 'Circulatie- en filterpompen' },
    'uvc-units':                      { title: 'UV-C units',                 sub: 'Zweefalg bestrijden met UV-C' },
    'uvc-vervanglampen':              { title: 'UV-C vervanglampen',         sub: 'Jaarlijkse vervanging' },
    'draadalg-bestrijden':            { title: 'Draadalg bestrijden',        sub: 'Mechanisch én chemisch' },
    'zweefalg-bestrijden':            { title: 'Zweefalg bestrijden',        sub: 'Groen water helder krijgen' },
    'algenbestrijding':               { title: 'Algenbestrijding',           sub: 'Volledig aanbod algmiddelen' },
    'zuurstoftekort-oplossen':        { title: 'Zuurstof bijsturen',         sub: 'Beluchting en zuurstof-tabs' },
    'luchtpompen-beluchting':         { title: 'Luchtpompen & beluchting',   sub: 'O₂ bijvoeren bij hitte of crisis' },
    'visziekten-medicijnen':          { title: 'Visziekte-medicijnen',       sub: 'Medicatie en behandelmiddelen' },
    'zieke-vissen-behandelen':        { title: 'Zieke vissen behandelen',    sub: 'Compleet behandel-protocol' },
    'filtermedia':                    { title: 'Filtermedia',                sub: 'Matten, spons, bio-media, zeoliet' },
    'drukfilters':                    { title: 'Drukfilters',                sub: 'Compacte filters voor kleinere vijvers' },
    'trommelfilters':                 { title: 'Trommelfilters',             sub: 'Top-klasse voor koi-vijvers' },
    'bodemslib-verwijderen':          { title: 'Bodemslib verwijderen',      sub: 'Slibzuigers en bacteriële afbraak' },
    'vijverstofzuigers':              { title: 'Vijverstofzuigers',          sub: 'Bodem-slib direct afvoeren' },
    'vijver-voorjaarsopstart':        { title: 'Voorjaarsopstart',           sub: 'Alles voor een goede start' },
    'vijver-herfstklaar':             { title: 'Herfst klaarmaken',          sub: 'Bladval en afbouw voorbereiden' },
    'vijver-winterklaar':             { title: 'Winterklaar maken',          sub: 'Beluchting en ijsvrijhouders' },
    'vijver-zomer-hitte':             { title: 'Zomer-hittebeheer',          sub: 'Zuurstof, schaduw, voerbeheer' },
    'reigerbescherming-dierenwering': { title: 'Reigerbescherming',          sub: 'Netten, draden en schrikmiddelen' },
    'schepnetten-meetbakken':         { title: 'Schepnetten & bakken',       sub: 'Vangen en behandelen' },
    'nieuwe-vijver-opstarten':        { title: 'Nieuwe vijver opstarten',    sub: 'Van zand naar gezond water' },
    'waterpest':                      { title: 'Waterpest',                  sub: 'Zuurstofplanten voor de vijver' },
    'waterplanten':                   { title: 'Waterplanten',               sub: 'Zuurstof- en sier-planten' },
    'vijververwarming-ijsvrijhouders':{ title: 'Verwarming & ijsvrijhouders', sub: 'Tegen zuurstofgat in winter' }
  });

  function humanizeCollection(handle) {
    if (!handle || typeof handle !== 'string') return { title: '', sub: '' };
    const h = handle.trim();
    if (COLLECTION_LABELS[h]) return COLLECTION_LABELS[h];
    // Fallback: hyphens → spaties, eerste letter hoofd. Geen sub.
    const spaced = h.replace(/-+/g, ' ').trim();
    return { title: spaced.charAt(0).toUpperCase() + spaced.slice(1), sub: '' };
  }

  // ──────────────────────────────────────────────────────────────
  // PRODUCT-DEDUPE
  //
  // Triggers kunnen dezelfde producten suggereren, en een enkel
  // product kan meerdere variant-id's hebben. Dedupe op URL-handle
  // is betrouwbaarder dan op p.id: de URL is de canonieke identiteit
  // van een product op de site. Klanten willen nooit 3x hetzelfde
  // product naast elkaar zien.
  // ──────────────────────────────────────────────────────────────
  function productHandle(p) {
    if (!p) return null;
    if (p.handle) return String(p.handle);
    if (p.url) {
      const m = String(p.url).match(/\/products\/([^?#\/]+)/);
      if (m) return m[1];
    }
    if (p.id != null) return 'id:' + p.id;
    return null;
  }

  function uniqueProducts(iter) {
    const seen = new Set();
    const out = [];
    for (const item of iter) {
      const p = item && item.product ? item.product : item;
      const key = productHandle(p);
      if (key && !seen.has(key)) {
        seen.add(key);
        out.push(item);
      }
    }
    return out;
  }

  // ──────────────────────────────────────────────────────────────
  // SEVERITY-TOKENS + BRAND VOICE TICS
  //
  // Rule-engine output heeft urgency ∈ {rood, oranje, geel, groen}.
  // Die mappen we op de design-spec severity-tokens ∈ {crit, alert,
  // warn, ok, info}. Severity-token drijft:
  //   1) `data-vw-severity` attribuut op de card (CSS border+bg)
  //   2) de Brand Voice Tic-prefix die de copy opent
  //
  // Tic-regel (brandbook v3.2): minimaal één Tic per gelezen stuk tekst.
  // Strategy: als de rule-copy al met een Tic begint, geen dubbele
  // prefix. Anders prepend Tic per severity, zo krijgt elke card de
  // juiste toon: kritiek = direct, observatie = casual.
  // ──────────────────────────────────────────────────────────────
  const URGENCY_TO_SEVERITY = Object.freeze({
    rood:   'crit',
    oranje: 'alert',
    geel:   'warn',
    groen:  'ok',
    // Toekomst: server-side urgency='blauw' of urgency='observe' zou
    // mappen op 'info' (drift-waarneming zonder actie).
    blauw:  'info',
    observe:'info'
  });

  const TICS_BY_SEVERITY = Object.freeze({
    crit:  'Ons advies:',              // direct, urgent
    alert: 'Wat we vaak zien:',         // observerend, niet bang maken
    warn:  'Tip van de specialist:',    // behulpzaam, uitnodigend
    info:  'Gezien de situatie:',       // neutraal, feitelijk
    ok:    'In onze ervaring:'           // ontspannen, seizoens-tip
  });

  const TIC_PREFIXES_LC = [
    'ons advies', 'wat we vaak zien', 'tip van de specialist',
    'gezien de situatie', 'in onze ervaring', 'eerlijk gezegd',
    'onze ervaring leert', 'wat wij zien'
  ];

  function severityFromUrgency(urgency) {
    return URGENCY_TO_SEVERITY[urgency] || 'ok';
  }

  function copyStartsWithTic(copy) {
    if (!copy) return false;
    const head = String(copy).trim().toLowerCase();
    return TIC_PREFIXES_LC.some(t => head.startsWith(t));
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
  }

  function applyBrandVoiceTic(copy, severity) {
    const clean = String(copy || '').trim();
    if (!clean) return '';
    if (copyStartsWithTic(clean)) return escapeHtml(clean);
    const tic = TICS_BY_SEVERITY[severity] || TICS_BY_SEVERITY.ok;
    return '<strong class="vw-tic">' + escapeHtml(tic) + '</strong> ' + escapeHtml(clean);
  }

  // ──────────────────────────────────────────────────────────────
  // API CLIENT
  // ──────────────────────────────────────────────────────────────
  async function api(path, { method = 'GET', body = null, idempotency = false, signal = null } = {}) {
    const url = CFG.apiBaseUrl.replace(/\/+$/, '') + path;
    const ctrl = signal ? null : new AbortController();
    const timeout = ctrl ? setTimeout(() => ctrl.abort(), CFG.requestTimeoutMs) : null;
    const headers = {
      'Accept': 'application/json',
      'X-VW-Anon-Key': CFG.apiAnonKey,
      'X-VW-Client': 'shopify-section/0.2.0',
      'X-Request-Id': uuidv7()
    };
    if (body) headers['Content-Type'] = 'application/json';
    if (idempotency) headers['Idempotency-Key'] = uuidv7();
    if (CFG.rulesVersionPin) headers['X-VW-Rules-Version'] = String(CFG.rulesVersionPin);

    try {
      const r = await fetch(url, {
        method, headers, body: body ? JSON.stringify(body) : undefined,
        signal: signal || (ctrl && ctrl.signal), credentials: 'omit', mode: 'cors'
      });
      if (timeout) clearTimeout(timeout);
      if (!r.ok) {
        let payload = null;
        try { payload = await r.json(); } catch (_) {}
        return { ok: false, status: r.status, errors: (payload && payload.errors) || [] };
      }
      const json = await r.json();
      return { ok: true, status: r.status, ...json };
    } catch (e) {
      if (timeout) clearTimeout(timeout);
      return { ok: false, status: 0, errors: [{ code: 'NETWORK', title: e.message }] };
    }
  }

  const vwApi = {
    // Backend is POST-only met LocationSchema body ({postcode} OF {lat,lon})
    geocode: postcode => api('/geocode', { method: 'POST', body: { postcode } }),
    reverseGeocode: (lat, lon) => api('/geocode', { method: 'POST', body: { lat, lon } }),
    forecast: (lat, lon, days, depth_cm) => {
      const qs = `lat=${lat}&lon=${lon}&days=${days || 7}` +
        (typeof depth_cm === 'number' && depth_cm > 0 ? `&depth_cm=${Math.round(depth_cm)}` : '');
      return api(`/forecast?${qs}`);
    },
    collectionProducts: (handle, limit) => api(`/collection-products?handle=${encodeURIComponent(handle)}&limit=${limit || 3}`),
    advice: ctx => api('/advice', { method: 'POST', body: ctx }),
    rules: () => api('/rules'),
    subscribe: payload => api('/subscribe', { method: 'POST', body: payload, idempotency: true }), // CORS preflight server-side gefixt 2026-06-06
    events: payload => api('/events', { method: 'POST', body: payload, idempotency: true })
  };

  // ──────────────────────────────────────────────────────────────
  // CONSENT & ANALYTICS
  // ──────────────────────────────────────────────────────────────
  function hasAnalyticsConsent() {
    try { if (navigator.globalPrivacyControl === true) return false; } catch (_) {}
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
        return !!cp.analyticsProcessingAllowed();
      }
    } catch (_) {}
    try { if (typeof CFG.consentOverride === 'function') return !!CFG.consentOverride(); } catch (_) {}
    return !!CFG.defaultConsent;
  }

  const _eventQueue = [];
  let _flushTimer = null;

  function queueEvent(name, props) {
    _eventQueue.push({ name, ts: new Date().toISOString(), properties: props || {} });
    if (_flushTimer) return;
    _flushTimer = setTimeout(flushEvents, 1500);
  }

  async function flushEvents() {
    _flushTimer = null;
    if (_eventQueue.length === 0) return;
    const batch = _eventQueue.splice(0, _eventQueue.length);
    try {
      await vwApi.events({
        profile_id: getOrCreateSessionId(),
        events: batch,
        source: 'vijvercheck-widget',
        page: { url: location.href, referrer: document.referrer, title: document.title }
      });
    } catch (_) {}
  }

  // Events die vlak voor een paginanavigatie vuren: niet in de 1500 ms-batch stoppen.
  const NAV_EVENTS = ['vw_product_click','vw_collection_click','vw_add_to_cart','vw_equipment_click','vw_vet_cta_click'];
  // Verbetercyclus run 8 (04-08-2026): het blob-type MOET CORS-safelisted zijn.
  // Met application/json is de beacon een preflighted request; die OPTIONS breekt de
  // browser af zodra het document unloadt, dus precies bij een kliknavigatie. Headless
  // bewijs 04-08 op 390 breed: net::ERR_FAILED op de beacon van vw_product_click,
  // terwijl niet-navigerende batches gewoon 202 kregen. text/plain is safelisted (geen
  // preflight) en de edge-function parseert de body los van het content-type; getoetst
  // met een directe POST: 202 en rij 2689 in de events-tabel.
  function sendNow(name, props) {
    try {
      if (!navigator.sendBeacon) return false;
      const payload = JSON.stringify({
        profile_id: getOrCreateSessionId(),
        events: [{ name: name, ts: new Date().toISOString(), properties: props || {} }],
        source: 'vijvercheck-widget',
        page: { url: location.href, referrer: document.referrer, title: document.title }
      });
      return navigator.sendBeacon(
        CFG.apiBaseUrl.replace(/\/+$/, '') + '/events',
        new Blob([payload], { type: 'text/plain;charset=UTF-8' })
      );
    } catch (_) { return false; }
  }

  // Verbetercyclus run 9 (11-08-2026): de collection-products API levert price als
  // opgemaakte string, bijvoorbeeld "\u20ac56,69". parseFloat daarvan is NaN, dus elk
  // klik- en add-to-cart-event droeg value 0 en advies-naar-order omzet was niet te
  // meten. vwPriceNum strip het valutateken, behandelt de punt als duizendtalscheiding
  // en de komma als decimaalscheiding, en valt terug op 0 bij onleesbare invoer.
  function vwPriceNum(v) {
    if (typeof v === 'number') return isFinite(v) ? v : 0;
    var s = String(v == null ? '' : v).replace(/[^0-9,.\-]/g, '');
    if (s.indexOf(',') > -1) s = s.replace(/\./g, '').replace(',', '.');
    var n = parseFloat(s);
    return isFinite(n) ? n : 0;
  }

  function track(eventName, params) {
    params = params || {};
    // GA4: niet gaten op CFG.ga4MeasurementId. Die themasetting stond leeg, waardoor
    // ALLE vijvercheck-events (incl. de save-funnel) nooit in GA4 aankwamen.
    // gtag is globaal aanwezig via de Shopify GA4-app; zelfde aanpak als klantvijvers meet().
    try { if (typeof gtag === 'function') gtag('event', eventName, params); } catch (_) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName, ts: Date.now() }, params));
    } catch (_) {}
    if (hasAnalyticsConsent()) {
      // Verbetercyclus run 7 (28-07-2026): klik-events die direct gevolgd worden door
      // een navigatie (window.location.href) gingen verloren. queueEvent wacht 1500 ms
      // op de batch-flush, maar dan is de pagina al weg, en de beforeunload-beacon is
      // op mobiel onbetrouwbaar. Gevolg: 0 vw_product_click, vw_collection_click en
      // vw_add_to_cart in 7 dagen, terwijl niet-navigerende events (vw_card_toggle,
      // vw_mode_change, vw_forecast_toggle) wel gewoon binnenkwamen. Deze events gaan
      // nu direct mee met sendBeacon; de queue blijft de terugvalweg.
      if (NAV_EVENTS.indexOf(eventName) !== -1 && sendNow(eventName, params)) return;
      queueEvent(eventName, params);
    }
  }

  // vw-expose-track FIX (verbetercyclus run 6, 24-07-2026): de oude expose-regel
  // stond BUITEN deze IIFE, waardoor typeof track daar 'undefined' was en
  // window.vwTrack nooit werd gezet. Gevolg: de complete vw_save-funnel in
  // vijvercheck-save.js viel terug op dataLayer en landde nooit in GA4 of in de
  // eigen events-tabel (0 vw_save_* events tussen 19-07 en 24-07).
  try { if (!window.vwTrack) window.vwTrack = track; } catch (_) {}

  function trackConversion(labelKey, value) {
    if (!CFG.gadsConversionId) return;
    try {
      gtag('event', 'conversion', {
        send_to: CFG.gadsConversionId + '/' + labelKey,
        value: value || 0,
        currency: CFG.shopCurrency
      });
    } catch (_) {}
    queueEvent('conversion_client', { label: labelKey, value: value, currency: CFG.shopCurrency });
  }

  window.addEventListener('beforeunload', () => {
    if (_eventQueue.length === 0) return;
    if (!hasAnalyticsConsent()) { _eventQueue.length = 0; return; }
    try {
      const payload = JSON.stringify({
        profile_id: getOrCreateSessionId(),
        events: _eventQueue.splice(0)
      });
      navigator.sendBeacon(
        CFG.apiBaseUrl.replace(/\/+$/, '') + '/events',
        new Blob([payload], { type: 'text/plain;charset=UTF-8' })
      );
    } catch (_) {}
  });

  try {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.onVisitorConsentCollected === 'function') {
      cp.onVisitorConsentCollected(function () {
        if (!hasAnalyticsConsent()) {
          _eventQueue.length = 0;
          if (_flushTimer) { clearTimeout(_flushTimer); _flushTimer = null; }
        }
      });
    }
  } catch (_) {}

  // ──────────────────────────────────────────────────────────────
  // RENDERING
  // ──────────────────────────────────────────────────────────────
    function renderAdviceSummary(advice) {
    // 1) Hero-tips (#vw-tips): top-3 lijst (backward compat).
    const tipsRoot = $('#vw-tips');
    if (tipsRoot) {
      if (!advice || advice.length === 0) {
        tipsRoot.innerHTML = '<div class="text-sm text-slate-500">Geen adviezen voor vandaag. Alles ziet er rustig uit.</div>';
      } else {
        // CSS-stip per urgentie, geen emoji (UI-richtlijn 16-10-2026).
        const dots = { rood: 'bg-red-500', oranje: 'bg-orange-500', geel: 'bg-yellow-400', groen: 'bg-green-500' };
        const top = advice.slice(0, 3);
        const items = top.map(function (a) { return [
          '<li class="flex items-start gap-2">',
          '  <span aria-hidden="true" class="flex-shrink-0 inline-block w-2.5 h-2.5 rounded-full mt-1.5 ' + (dots[a.urgency] || dots.groen) + '"></span>',
          '  <span class="flex-1 leading-snug">' + (a.title || '') + '</span>',
          '</li>'
        ].join(''); }).join('');
        const rest = advice.length > top.length
          ? '<div class="text-xs text-slate-500 mt-2">+ ' + (advice.length - top.length) + ' meer in volledig advies hieronder.</div>'
          : '';
        tipsRoot.innerHTML = '<ul class="space-y-1.5 text-sm text-slate-700">' + items + '</ul>' + rest;
      }
    }
    // 2) Sticky 1-regel summary boven advies-cards (Agent B refactor 2026-05-27).
    const stickyRoot = $('#vw-advies-summary');
    if (!stickyRoot) return;
    if (!advice || advice.length === 0) {
      stickyRoot.hidden = true;
      stickyRoot.innerHTML = '';
      return;
    }
    var n = { rood: 0, oranje: 0, geel: 0, groen: 0 };
    advice.forEach(function (a) { if (n[a.urgency] != null) n[a.urgency]++; });
    var parts = [];
    var sdot = function (cls) { return '<span aria-hidden="true" class="inline-block w-2 h-2 rounded-full ' + cls + '"></span>'; };
    if (n.rood)   parts.push('<span class="inline-flex items-center gap-1 font-semibold text-red-700">' + sdot('bg-red-500') + n.rood + ' actie nodig</span>');
    if (n.oranje) parts.push('<span class="inline-flex items-center gap-1 font-semibold text-orange-700">' + sdot('bg-orange-500') + n.oranje + ' let op</span>');
    if (n.geel)   parts.push('<span class="inline-flex items-center gap-1 font-semibold text-amber-700">' + sdot('bg-yellow-400') + n.geel + ' tip</span>');
    if (n.groen)  parts.push('<span class="inline-flex items-center gap-1 font-semibold text-emerald-700">' + sdot('bg-green-500') + n.groen + ' OK</span>');
    var tail = '<span class="text-slate-500 ml-auto text-xs">' + advice.length + ' ' + (advice.length === 1 ? 'advies' : 'adviezen') + ' hieronder</span>';
    stickyRoot.innerHTML = parts.join('<span class="text-slate-500" aria-hidden="true">|</span>') + tail;
    stickyRoot.hidden = false;
  }

  // ─── Agent 2 HERO+SUBBAR 2026-05-27 ───
  // Populeert #vw-advies-subbar (location + counts + timestamp) en toont
  // 'm na de eerste advies-render. Lost "chaos / lappen tekst"-feedback op
  // door blijvende status-strip tijdens scrollen door advies-cards.
  function renderAdviceSubbar(response) {
    var bar = document.getElementById('vw-advies-subbar');
    if (!bar || !response || !response.data) return;
    var data = response.data || {};
    var advice = Array.isArray(data.advice) ? data.advice : [];
    var loc = data.location || {};
    // Locatie-string: postcode + plaats (+ BE-suffix bij Belgische postcodes).
    var pc = loc.postcode || '';
    var plaats = loc.plaats || loc.gemeente || '';
    var country = loc.country || '';
    var locText = '';
    if (pc && plaats) {
      locText = pc + (country === 'BE' ? ' · ' + plaats + ' (BE)' : ' · ' + plaats);
    } else if (plaats) {
      locText = plaats;
    } else if (pc) {
      locText = pc;
    } else {
      locText = 'Locatie onbekend';
    }
    var locEl = document.getElementById('vw-subbar-loc');
    if (locEl) locEl.textContent = locText;
    // Diepte waarmee dit advies is berekend (Stap 1 keuze of exacte waarde uit Stap 2).
    var depthEl = document.getElementById('vw-subbar-depth');
    if (depthEl) {
      var ctxPond = (window.__vwLastCtx && window.__vwLastCtx.pond) || {};
      var dcm = parseInt(ctxPond.depth_cm, 10);
      depthEl.textContent = Number.isFinite(dcm) ? '· diepte ' + dcm + ' cm' : '';
    }
    // Counts per urgency.
    var n = { rood: 0, oranje: 0, geel: 0, groen: 0 };
    advice.forEach(function (a) { if (a && n[a.urgency] != null) n[a.urgency]++; });
    var countsEl = document.getElementById('vw-subbar-counts');
    if (countsEl) {
      var pills = [];
      // Statusbadges met een CSS-stip, geen emoji (UI-richtlijn 16-10-2026).
      var dot = function (cls) { return '<span aria-hidden="true" class="inline-block w-2 h-2 rounded-full ' + cls + '"></span>'; };
      if (n.groen)  pills.push('<span class="inline-flex items-center gap-1 bg-green-50 text-green-700 px-2 py-1 rounded" title="' + n.groen + ' op orde">' + dot('bg-green-500') + n.groen + '</span>');
      if (n.geel)   pills.push('<span class="inline-flex items-center gap-1 bg-yellow-50 text-yellow-700 px-2 py-1 rounded" title="' + n.geel + ' tip">' + dot('bg-yellow-400') + n.geel + '</span>');
      if (n.oranje) pills.push('<span class="inline-flex items-center gap-1 bg-orange-50 text-orange-700 px-2 py-1 rounded" title="' + n.oranje + ' let op">' + dot('bg-orange-500') + n.oranje + '</span>');
      if (n.rood)   pills.push('<span class="inline-flex items-center gap-1 bg-red-50 text-red-700 px-2 py-1 rounded" title="' + n.rood + ' actie nodig">' + dot('bg-red-500') + n.rood + '</span>');
      countsEl.innerHTML = pills.join('');
    }
    // Timestamp (alleen md+).
    var timeEl = document.getElementById('vw-subbar-time');
    if (timeEl) {
      var d = new Date();
      var hh = String(d.getHours()).padStart(2, '0');
      var mm = String(d.getMinutes()).padStart(2, '0');
      timeEl.textContent = 'ververst ' + hh + ':' + mm;
    }
    // Show áltijd na eerste render (ook bij 0 adviezen, dan toon je nog steeds locatie).
    bar.classList.remove('hidden');
    bar.hidden = false;
  }

  // Rules die een dierenarts-consult vereisen kenmerken zich met de
  // trigger `dierenarts_doorstuur`. Bij deze rules wordt de product-strook
  // VERVANGEN door een crisis-card: product-crosssell zou misleidend zijn
  // (er is GEEN OTC-behandeling voor KHV/CyHV-2/SVK/dropsy/pop-eye). De
  // `meldingsplicht`-trigger is een tweede marker: bij die rules moet de
  // houder óók melden bij NVWA (alleen B001/B002/B010).
  function requiresVetGate(a) {
    return Array.isArray(a && a.triggers) && a.triggers.indexOf('dierenarts_doorstuur') !== -1;
  }
  function requiresNvwaReport(a) {
    return Array.isArray(a && a.triggers) && a.triggers.indexOf('meldingsplicht') !== -1;
  }

  // ─── Agent B refactor 2026-05-27: collapse-state + copy shortener ───
  var VW_EXPANDED_KEY = 'vw_card_expanded_v1';
  function vwGetExpandedSet() {
    try {
      var raw = localStorage.getItem(VW_EXPANDED_KEY);
      if (!raw) return new Set();
      var arr = JSON.parse(raw);
      return new Set(Array.isArray(arr) ? arr : []);
    } catch (_) { return new Set(); }
  }
  function vwSetExpanded(ruleId, expanded) {
    if (!ruleId) return;
    var s = vwGetExpandedSet();
    if (expanded) s.add(ruleId); else s.delete(ruleId);
    try { localStorage.setItem(VW_EXPANDED_KEY, JSON.stringify(Array.from(s))); } catch (_) {}
  }
  function vwShortSummary(text, maxWords) {
    if (!text) return '';
    var clean = String(text).replace(/\s+/g, ' ').trim();
    // Strip HTML tags voor de summary-regel.
    clean = clean.replace(/<[^>]+>/g, '');
    var words = clean.split(' ');
    if (words.length <= maxWords) return clean;
    return words.slice(0, maxWords).join(' ') + '\u2026';
  }
  // Agent 1 (EENVOUDIG) 2026-05-27: truncate titles to N words.
  function vwTruncateWords(text, maxWords) {
    if (!text) return '';
    var clean = String(text).replace(/<[^>]+>/g, '').replace(/\s+/g,' ').trim();
    var w = clean.split(' ');
    if (w.length <= maxWords) return clean;
    return w.slice(0, maxWords).join(' ') + '\u2026';
  }
  function vwFirstSentence(text) {
    if (!text) return '';
    var clean = String(text).replace(/<[^>]+>/g, '').trim();
    var m = clean.match(/^[^.!?]+[.!?]/);
    return m ? m[0].trim() : clean;
  }
  function vwCountWords(text) {
    if (!text) return 0;
    return String(text).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().split(' ').filter(Boolean).length;
  }

  function renderKlantvijversKaart(root, advice) {
    if (!root || root.getAttribute('data-vw-kv-kaart') !== 'true') return;
    if (!advice || !advice.length) return;
    var allesGroen = advice.every(function (a) { return a && a.urgency === 'groen'; });
    if (!allesGroen) return;
    var tegoed = root.getAttribute('data-vw-kv-tegoed') || '';
    var kaart = document.createElement('aside');
    kaart.className = 'vw-kv-kaart rounded-2xl border border-aqua/30 bg-aqua/5 p-5 flex flex-col sm:flex-row sm:items-center gap-4';
    kaart.setAttribute('aria-label', 'Laat je vijver zien');
    kaart.innerHTML =
      '<div class="flex-1 min-w-0">' +
        '<p class="font-display font-bold text-navy text-lg m-0 mb-1">Alles staat op groen</p>' +
        '<p class="text-sm text-slate-600 m-0">Mooi moment om je vijver te laten zien in de klantvijvers-galerij' +
          (tegoed ? '. Na goedkeuring krijg je &euro;' + escapeHtml(tegoed) + ' winkeltegoed.' : '.') + '</p>' +
      '</div>' +
      '<a href="/pages/klantvijvers-insturen?bron=vijvercheck" class="shrink-0 inline-flex items-center justify-center gap-2 bg-koi text-white font-bold py-3 px-5 rounded-xl text-sm no-underline min-h-[44px]" data-vw-kv-kaart-link>Stuur je vijver in</a>';
    root.appendChild(kaart);
    track('vw_klantvijvers_kaart_getoond', {});
    var link = kaart.querySelector('[data-vw-kv-kaart-link]');
    if (link) link.addEventListener('click', function () { track('vw_klantvijvers_kaart_klik', {}); });
  }

  function renderAdviceCards(response, targetSel) {
    const root = $(targetSel || '#vw-advies-cards');
    if (!root || !response || !response.data) return;
    var { advice = [], product_suggestions = {}, equipment_suggestions = {} } = response.data;
    // Agent B refactor 2026-05-27: sorteer op urgency (rood > oranje > geel > groen).
    var _vwUrgencyOrder = { rood: 0, oranje: 1, geel: 2, groen: 3 };
    advice = (advice || []).slice().sort(function (a, b) {
      return (_vwUrgencyOrder[a && a.urgency] != null ? _vwUrgencyOrder[a.urgency] : 4)
           - (_vwUrgencyOrder[b && b.urgency] != null ? _vwUrgencyOrder[b.urgency] : 4);
    });
    renderAdviceSummary(advice);
    // Agent 2 HERO+SUBBAR 2026-05-27: status-strip boven advies-cards.
    try { renderAdviceSubbar(response); } catch (_) {}
    // Bij eerste render: top-card automatisch expanded; alle rode altijd expanded.
    var _vwExpanded = vwGetExpandedSet();
    var _vwFirstShown = false;
    const frag = document.createDocumentFragment();

    // Cross-card product-dedupe: hetzelfde product 3× over verschillende
    // advies-cards lezen ondermijnt autoriteit ("oogt lui, suggereert
    // dat er geen passender alternatief is"). Omdat `advice` al op
    // severity gesorteerd is (crit > alert > warn > info), wint het
    // meest-kritieke advies z'n eerste keuze, volgende cards krijgen
    // varianten uit hetzelfde problem-domein maar een andere SKU.
    // Als een card door dedupe <1 product overhoudt, vult vendor-
    // fallback (nog niet beschikbaar) op; voor nu accepteren we een
    // kortere lijst boven herhaling.
    const seenAcrossCards = new Set();

    advice.forEach(a => {
      const severity = severityFromUrgency(a.urgency);
      const card = document.createElement('article');
      // Oude urgency-class blijft voor backward-compat met analytics en
      // custom CSS; `data-vw-severity` is de nieuwe canonieke hook.
      card.className = 'vw-card vw-urgency-' + (a.urgency || 'groen') + ' rounded-lg border border-gray-200 p-4 mb-3';
      card.dataset.ruleId = a.rule_id;
      card.setAttribute('data-vw-severity', severity);
      card.setAttribute('data-vw-component', 'advice-card');
      // a11y: rode (levensbedreigende) kaarten worden assertief aangekondigd
      // door screenreaders (role=alert); gele/groene blijven role=region.
      card.setAttribute('role', a.urgency === 'rood' ? 'alert' : 'region');
      card.setAttribute('aria-labelledby', 'vw-rule-' + (a.rule_id || '0'));

      // Expliciete, actiegerichte labels ipv "Snel"/"Week" (cryptisch).
      // Confidence wordt bewust NIET getoond: het wordt server-side 1-op-1 afgeleid
      // van urgency, dus een apart "Zekerheid"-veld dupliceert informatie en leest
      // alsof we twijfelen aan het advies. De API-response behoudt confidence voor
      // later gebruik (echte bronnen-gewogen score).
      const urgencyLabels = {
        rood:   'Nu handelen',
        oranje: 'Deze week',
        geel:   'Binnen 2 weken',
        groen:  'Tip'
      };

      // Agent 1 (EENVOUDIG) 2026-05-27: pill + urgency-dot + 6-word-title + chevron
      const pillLabels = {
        rood:   'Nu actie',
        oranje: 'Vandaag',
        geel:   'Deze week',
        groen:  'OK'
      };
      const _u = a.urgency || 'groen';
      const _pill = pillLabels[_u] || 'OK';
      const _titleFull = (a.title || '').trim();
      const _titleShort = vwTruncateWords(_titleFull, 6);
      const _titleEsc = _titleShort
        .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
      const _titleTipAttr = (_titleShort !== _titleFull)
        ? ' title="' + _titleFull.replace(/&/g,'&amp;').replace(/"/g,'&quot;') + '"'
        : '';
      const header = document.createElement('header');
      header.className = 'vw-card-header border-b border-gray-200 pb-2 mb-2';
      header.innerHTML = [
        '<div class="flex items-center gap-2">',
        '  <span aria-hidden="true" class="vw-urgency-dot" data-urg="' + _u + '"></span>',
        '  <h3 id="vw-rule-' + (a.rule_id || '0') + '" class="flex-1 min-w-0 font-semibold text-base text-navy"' + _titleTipAttr + '>' + _titleEsc + '</h3>',
        '  <span class="vw-status-pill" data-pill="' + _u + '" aria-label="Urgentie: ' + _pill + '">' + _pill + '</span>',
        '  <svg class="vw-head-chev w-4 h-4 text-slate-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>',
        '</div>',
        '<p class="text-xs text-slate-600 mt-1 vw-card-actionhint" hidden><strong>Actie:</strong> ' + (urgencyLabels[a.urgency] || 'Tip') + '</p>',
        '</header>'
      ].join('');
      card.appendChild(header);

      // Agent B refactor 2026-05-27: collapse-state + toggle.
      // Agent 1 (EENVOUDIG) 2026-05-27: in Eenvoudig-modus géén auto-expand van eerste card
      // (Bregje wil 1-regel cards; rood blijft wel verplicht open i.v.m. veiligheid).
      var _vwModeNow = (root && root.getAttribute('data-vw-mode')) || (document.body.getAttribute('data-vw-advies-mode') || 'volledig');
      var _isRed = (a.urgency === 'rood');
      var _isFirst = !_vwFirstShown;
      _vwFirstShown = true;
      var _explicit = a.rule_id && _vwExpanded.has(a.rule_id);
      var _autoFirstAllowed = (_vwModeNow !== 'eenvoudig');
      var _collapsedDefault = !(_isRed || (_isFirst && _autoFirstAllowed) || _explicit);
      card.setAttribute('data-vw-collapsed', _collapsedDefault ? 'true' : 'false');
      card.setAttribute('data-vw-urgency', a.urgency || 'groen');

      // Korte samenvatting (max 12 woorden) voor collapsed-state.
      var _summaryText = vwShortSummary(a.copy_nl || a.title || '', 12);
      var summaryEl = document.createElement('div');
      summaryEl.className = 'vw-card-summary text-sm text-slate-600 pt-1';
      summaryEl.textContent = _summaryText;
      card.appendChild(summaryEl);

      // Toggle-knop rechts in header (a11y: button, aria-expanded, aria-controls).
      var _bodyId = 'vw-card-body-' + (a.rule_id || Math.random().toString(36).slice(2));
      var toggleBtn = document.createElement('button');
      toggleBtn.type = 'button';
      toggleBtn.className = 'vw-card-toggle inline-flex items-center gap-1 text-xs font-semibold text-aqua-donker min-h-[44px] px-2 -mx-2 mt-1 focus-visible:ring-brand-focus';
      toggleBtn.setAttribute('aria-controls', _bodyId);
      toggleBtn.setAttribute('aria-expanded', _collapsedDefault ? 'false' : 'true');
      toggleBtn.innerHTML = '<span class="vw-toggle-label">' + (_collapsedDefault ? 'Lees meer' : 'Inklappen') + '</span>'
        + '<svg class="vw-chev w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>';
      toggleBtn.addEventListener('click', function () {
        var nowCollapsed = card.getAttribute('data-vw-collapsed') === 'true';
        var next = !nowCollapsed;
        card.setAttribute('data-vw-collapsed', next ? 'true' : 'false');
        toggleBtn.setAttribute('aria-expanded', next ? 'false' : 'true');
        var lbl = toggleBtn.querySelector('.vw-toggle-label');
        if (lbl) lbl.textContent = next ? 'Lees meer' : 'Inklappen';
        vwSetExpanded(a.rule_id, !next);
        try { track('vw_card_toggle', { rule_id: a.rule_id, expanded: !next }); } catch (_) {}
      });
      // Agent 1 (EENVOUDIG): header zelf is klikbaar in Eenvoudig (toggle-btn is hidden).
      header.setAttribute('role', 'button');
      header.setAttribute('tabindex', '0');
      header.setAttribute('aria-controls', _bodyId);
      header.addEventListener('click', function (ev) {
        if (ev.target && (ev.target.closest && ev.target.closest('a,button'))) return;
        toggleBtn.click();
      });
      header.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); toggleBtn.click(); }
      });
      card.appendChild(toggleBtn);

      // Body-wrapper: alle volgende secties komen erin via een proxy `card`-ref.
      var _bodyWrap = document.createElement('div');
      _bodyWrap.className = 'vw-card-body mt-2';
      _bodyWrap.id = _bodyId;
      card.appendChild(_bodyWrap);
      var _origAppend = card.appendChild.bind(card);
      card.appendChild = function (node) { return _bodyWrap.appendChild(node); };

      const body = document.createElement('div');
      body.className = 'text-body mb-3';
      // Brand Voice Tic wordt als <strong class="vw-tic">…</strong>
      // voor de copy geplakt. applyBrandVoiceTic() escapet de
      // klant-copy veilig en zorgt dat er geen dubbele Tics ontstaan
      // wanneer de rule-author zelf al met een Tic schrijft.
      // Agent B refactor 2026-05-27: lappen-tekst opsplitsen.
      var _copyHtml = applyBrandVoiceTic(a.copy_nl || '', severity);
      var _wordCount = vwCountWords(a.copy_nl || '');
      if (_wordCount > 40) {
        var _first = vwFirstSentence(a.copy_nl || '');
        var _firstHtml = applyBrandVoiceTic(_first, severity);
        body.innerHTML = _firstHtml
          + ' <button type="button" class="vw-copy-more-btn" aria-expanded="false">Volledige uitleg</button>'
          + '<div class="vw-copy-more mt-2 text-slate-600" hidden>' + _copyHtml + '</div>';
        var _mb = body.querySelector('.vw-copy-more-btn');
        var _mw = body.querySelector('.vw-copy-more');
        if (_mb && _mw) {
          _mb.addEventListener('click', function () {
            var open = _mw.hasAttribute('hidden') ? false : true;
            if (open) { _mw.setAttribute('hidden', ''); _mb.setAttribute('aria-expanded', 'false'); _mb.textContent = 'Volledige uitleg'; }
            else { _mw.removeAttribute('hidden'); _mb.setAttribute('aria-expanded', 'true'); _mb.textContent = 'Minder tonen'; }
          });
        }
      } else {
        body.innerHTML = _copyHtml;
      }
      card.appendChild(body);

      if (a.actions_timeline && a.actions_timeline.length) {
        const timeline = document.createElement('section');
        timeline.className = 'vw-timeline mb-3'
        timeline.innerHTML = '<h4 class="font-semibold text-small mb-2">Stap voor stap:</h4><ul class="space-y-1"></ul>';
        a.actions_timeline.forEach(t => {
          const li = document.createElement('li');
          li.className = 'text-small';
          li.innerHTML = '<strong>' + (t.when || 'Nu') + ':</strong> ' + (t.action || '');
          timeline.querySelector('ul').appendChild(li);
        });
        card.appendChild(timeline);
      }

      // ─── System-fit (Sprint 3): "past dit bij jouw vijver" o.b.v. profiel ───
      if (a.system_fit) {
        const sf = document.createElement('p');
        sf.className = 'vw-system-fit text-small text-navy border-l-4 border-aqua bg-aqua/5 rounded-r px-3 py-2 mb-3';
        sf.setAttribute('data-vw-component', 'system-fit');
        const safe = String(a.system_fit).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
        sf.innerHTML = '<strong>Past bij jouw vijver:</strong> ' + safe;
        card.appendChild(sf);
      }

      // ─── Disclaimer ──────────────────────────────────────────────────
      // De engine levert per (vooral rode) kaart een `disclaimer`-string
      // met de medische/wettelijke kanttekening. Visueel subtiel maar
      // duidelijk onderscheidend (kader + cursief) onder de actiepunten.
      if (a.disclaimer) {
        const disc = document.createElement('p');
        disc.className = 'vw-disclaimer text-small italic text-slate-600 border-l-4 border-slate-300 bg-slate-50 rounded-r px-3 py-2 mb-3';
        disc.setAttribute('data-vw-component', 'disclaimer');
        disc.textContent = a.disclaimer;
        card.appendChild(disc);
      }

      // ─── Dierenarts-verwijzing ───────────────────────────────────────
      // `vet_referral` true => duidelijke verwijzing naar een koi-
      // dierenarts plus Vijvercentrum-contact (e-mail + telefoon). Dit is
      // de lichte variant naast de zwaardere requiresVetGate()-crisiscard
      // (die volledige product-crosssell vervangt).
      if (a.vet_referral) {
        const vet = document.createElement('section');
        vet.className = 'vw-vet-referral mt-1 mb-3 rounded-lg border border-koi/40 bg-koi/5 p-3';
        vet.setAttribute('data-vw-component', 'vet-referral');
        const vetText = a.vet_referral_text
          || 'Bij zichtbare ziektesymptomen: raadpleeg een koi-dierenarts. Twijfel je? Neem contact op met Vijvercentrum.';
        vet.innerHTML = [
          '<div class="flex items-start gap-2">',
          '  <span aria-hidden="true" class="text-aqua-donker shrink-0 mt-0.5"><svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M4.8 2.3A.3.3 0 1 0 5 2H4a2 2 0 0 0-2 2v5a6 6 0 0 0 6 6 6 6 0 0 0 6-6V4a2 2 0 0 0-2-2h-1a.2.2 0 1 0 .3.3"/><path d="M8 15v1a6 6 0 0 0 6 6 6 6 0 0 0 6-6v-4"/><circle cx="20" cy="10" r="2"/></svg></span>',
          '  <div class="flex-1 min-w-0">',
          '    <p class="text-small text-navy font-semibold mb-1">Dierenarts-advies</p>',
          '    <p class="text-small text-slate-700 leading-snug mb-2"></p>',
          '    <p class="text-small text-slate-700">',
          '      <a href="mailto:service@vijvercentrum.nl" class="text-koi font-semibold underline focus-visible:ring-brand-focus">service@vijvercentrum.nl</a>',
          '    </p>',
          // B2 (audit 2026-05-24): prominente bel/WhatsApp-knoppen in de (rode) kaart
          // zelf, zodat de klant in een crisis niet de zwevende knoppen hoeft te zoeken.
          '    <div class="mt-2">',
          '      <a href="https://wa.me/31857732409" target="_blank" rel="noopener" class="vw-cta-wa inline-flex items-center gap-1.5 bg-koi text-white font-semibold rounded-lg px-3 py-2 text-sm hover:bg-orange-800 min-h-[44px] no-underline focus-visible:ring-brand-focus"><svg class="inline-block w-5 h-5 -mt-0.5 " xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg> WhatsApp Vijvercentrum</a>',
          '    </div>',
          '  </div>',
          '</div>'
        ].join('');
        // Klant-copy veilig als tekst zetten (geen HTML-injectie).
        vet.querySelector('.leading-snug').textContent = vetText;
        card.appendChild(vet);
      }

      if (a.sources && a.sources.length) {
        const footer = document.createElement('footer');
        footer.className = 'vw-sources text-xs text-gray-600 border-t border-gray-100 pt-2 mt-2';
        footer.innerHTML = '<details class="cursor-pointer"><summary class="font-semibold">Bronnen (' + a.sources.length + ')</summary><ul class="mt-1 space-y-0.5 list-disc list-inside text-gray-500"></ul></details>';
        a.sources.forEach(src => {
          const li = document.createElement('li');
          li.textContent = src;
          footer.querySelector('ul').appendChild(li);
        });
        card.appendChild(footer);
      }

      // ─── Dierenarts-gate ─────────────────────────────────────────────
      // B-rules met `dierenarts_doorstuur` trigger: ziektes waarvoor geen
      // OTC-behandeling bestaat (KHV, CyHV-2, SVK, dropsy, pop-eye).
      // Product-crosssell zou onjuist zijn; in plaats daarvan een crisis-
      // card met 3 acties: (1) koi-dierenarts zoeken, (2) NVWA melden bij
      // meldingsplicht, (3) WhatsApp-contact naar Vijvercentrum.
      if (requiresVetGate(a)) {
        const crisis = document.createElement('section');
        crisis.className = 'vw-crisis-card mt-3 rounded-lg border-2 border-red-300 bg-red-50 p-4';
        crisis.setAttribute('data-vw-component', 'crisis-card');
        const nvwa = requiresNvwaReport(a);
        const parts = [];
        parts.push('<div class="flex items-start gap-2 mb-3">');
        parts.push('  <span aria-hidden="true" class="text-red-600 shrink-0 mt-0.5"><svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"/><path d="M12 9v4"/><path d="M12 17h.01"/></svg></span>');
        parts.push('  <div class="flex-1">');
        parts.push('    <h4 class="font-semibold text-navy mb-1">Consulteer een vis-dierenarts</h4>');
        parts.push('    <p class="text-sm text-slate-700 leading-snug">Deze verdenking valt buiten zelf-behandeling. Een vis-dierenarts kan een stalkweek, PCR-test of secundaire infectie-behandeling organiseren. Over-the-counter middelen werken NIET op virale infecties.</p>');
        parts.push('  </div>');
        parts.push('</div>');
        parts.push('<div class="flex flex-wrap gap-2">');
        parts.push('  <a href="https://knmvd.nl/vind-een-dierenarts/" target="_blank" rel="noopener" class="vw-cta-vet inline-flex items-center gap-1.5 bg-koi text-white font-semibold rounded-lg px-3 py-2 text-sm hover:bg-orange-800 min-h-[44px] focus-visible:ring-brand-focus"><svg class="w-4 h-4 shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.8 2.3A.3.3 0 1 0 5 2H4a2 2 0 0 0-2 2v5a6 6 0 0 0 6 6 6 6 0 0 0 6-6V4a2 2 0 0 0-2-2h-1a.2.2 0 1 0 .3.3"/><path d="M8 15v1a6 6 0 0 0 6 6 6 6 0 0 0 6-6v-4"/><circle cx="20" cy="10" r="2"/></svg> Zoek koi-dierenarts</a>');
        if (nvwa) {
          parts.push('  <a href="https://www.nvwa.nl/onderwerpen/dierziekten/melden-van-besmettelijke-dierziekten" target="_blank" rel="noopener" class="vw-cta-nvwa inline-flex items-center gap-1.5 bg-red-600 text-white font-semibold rounded-lg px-3 py-2 text-sm hover:bg-red-700 min-h-[44px] focus-visible:ring-brand-focus"><svg class="w-4 h-4 shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 11v3a1 1 0 0 0 1 1h2l3 3V7L6 10H4a1 1 0 0 0-1 1z"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/></svg> Meld bij NVWA (verplicht)</a>');
        }
        parts.push('  <a href="https://wa.me/31857732409" target="_blank" rel="noopener" class="vw-cta-whatsapp inline-flex items-center gap-1.5 bg-white border border-slate-300 text-navy font-semibold rounded-lg px-3 py-2 text-sm hover:bg-slate-50 min-h-[44px] focus-visible:ring-brand-focus"><svg class="w-4 h-4 shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg> WhatsApp Vijvercentrum</a>');
        parts.push('</div>');
        crisis.innerHTML = parts.join('');
        // Track gate-render voor monitoring (ziektegevallen/maand).
        track('vw_vet_gate_shown', {
          rule_id: a.rule_id,
          meldingsplicht: nvwa
        });
        // Click-tracking per CTA (kwantificeren welk pad gebruikers kiezen).
        crisis.querySelectorAll('a[href]').forEach(el => {
          el.addEventListener('click', () => {
            track('vw_vet_cta_click', {
              rule_id: a.rule_id,
              cta: el.className.indexOf('vw-cta-vet') !== -1 ? 'vet'
                 : el.className.indexOf('vw-cta-nvwa') !== -1 ? 'nvwa'
                 : 'whatsapp'
            });
          });
        });
        card.appendChild(crisis);
        frag.appendChild(card);
        return; // geen product-crosssell + geen equipment bij vet-gate
      }

      const prodDiv = document.createElement('div');
      prodDiv.className = 'vw-products mt-3 space-y-2';
      if (a.triggers) {
        // Verzamel producten over ALLE triggers van deze ene advies-kaart,
        // dan dedupe op URL-handle. Twee triggers in één advies kunnen
        // overlappende producten leveren, zonder dedupe kreeg de klant
        // tot 3× hetzelfde product per kaart te zien.
        const candidates = [];
        a.triggers.forEach(trig => {
          (product_suggestions[trig] || []).forEach(p => {
            candidates.push({ product: p, trigger: trig });
          });
        });
        // Binnen-card unique + cross-card dedupe in één pass:
        // uniqueProducts() haalt intra-card duplicaten weg; daarna
        // filteren we op `seenAcrossCards` zodat dezelfde SKU niet 3×
        // over 3 cards loopt.
        //
        // EDGE CASE: sterk overlappende triggers (meerdere KH- of
        // NH4-cards die uit dezelfde product-pool putten) kunnen bij
        // strikt cross-card dedupe een card met 0 producten opleveren.
        // Een lege product-sectie leest als "niets beschikbaar" en
        // ondermijnt het advies. Daarom: als strict-dedupe niets
        // overlaat, vallen we terug op intra-card unique (repeats over
        // cards toestaan boven lege cards). Dat voorkomt dat card 3/4/5
        // in een chemie-crisis zonder product-verwijzing staat.
        const intraUnique = uniqueProducts(candidates);
        const strictUnique = intraUnique.filter(({ product: p }) => {
          const h = productHandle(p);
          return h && !seenAcrossCards.has(h);
        });
        const unique = (strictUnique.length > 0 ? strictUnique : intraUnique).slice(0, 3);
        unique.forEach(({ product: p, trigger: trig }) => {
          const handle = productHandle(p);
          if (handle) seenAcrossCards.add(handle);
          const link = document.createElement('a');
          link.className = 'vw-product block rounded-lg border border-gray-200 p-2 hover:border-aqua hover:shadow-soft transition-all';
          link.href = preserveUtm(p.url || '#');
          link.rel = 'noopener';
          if (p.id != null) link.dataset.productId = p.id;
          link.innerHTML = [
            '<div class="flex gap-2">',
            '  <img loading="lazy" alt="' + (p.title || 'Product') + '" class="w-12 h-12 object-cover rounded flex-shrink-0" src="' + (p.image || '') + '">',
            '  <div class="flex-1 min-w-0">',
            '    <div class="font-semibold text-small line-clamp-2">' + (p.title || '') + '</div>',
            '    <div class="text-xs text-[#C2410C] font-bold mt-1">' + (p.price || '?') + ' ' + CFG.shopCurrency + '</div>',
            '  </div>',
            '</div>'
          ].join('');
          link.addEventListener('click', ev => {
            ev.preventDefault();
            track('vw_product_click', {
              rule_id: a.rule_id,
              trigger: trig,
              product_id: p.id,
              value: vwPriceNum(p.price)
            });
            window.location.href = link.href;
          });
          prodDiv.appendChild(link);
        });
      }
      card.appendChild(prodDiv);

      // ─── Equipment-strip ───────────────────────────────────────────
      // Lange-termijn equipment (UV-lampen, sensoren, beluchtingssets) is
      // nuttig context bij preventief advies, maar afleidend tijdens een
      // acute rood/oranje crisis waar de directe remedie wint. UITZONDERING
      // (audit 2026-05-24, A1/A2): bij groen water/zweefalg IS de UV-C unit
      // (of vervanglamp) juist de hoofdoplossing, die kaart is oranje, dus
      // toon de equipment-strook daar ook. Contract: equipment_suggestions[trigger].
      var EQUIP_PRIMARY_TRIGGERS = ['green_water', 'algae_bloom'];
      var equipPrimary = (a.triggers || []).some(function (t) {
        return EQUIP_PRIMARY_TRIGGERS.indexOf(t) !== -1;
      });
      if (a.urgency === 'geel' || a.urgency === 'groen' || equipPrimary) {
        const equipCandidates = [];
        (a.triggers || []).forEach(trig => {
          (equipment_suggestions[trig] || []).forEach(p => {
            equipCandidates.push({ product: p, trigger: trig });
          });
        });
        const equipUnique = uniqueProducts(equipCandidates).slice(0, 3);
        if (equipUnique.length > 0) {
          const equipDiv = document.createElement('div');
          equipDiv.className = 'vw-equipment mt-3 pt-3 border-t border-slate-100';
          equipDiv.setAttribute('data-vw-component', 'equipment-strip');
          equipDiv.innerHTML = '<h4 class="font-semibold text-small text-slate-700 mb-2">Lange termijn:</h4><div class="vw-equipment-grid grid grid-cols-1 sm:grid-cols-3 gap-2"></div>';
          const grid = equipDiv.querySelector('.vw-equipment-grid');
          equipUnique.forEach(({ product: p, trigger: trig }) => {
            const link = document.createElement('a');
            link.className = 'vw-equipment-item block rounded-lg border border-slate-200 p-2 hover:border-aqua hover:shadow-soft transition-all';
            link.href = preserveUtm(p.url || '#');
            link.rel = 'noopener';
            if (p.id != null) link.dataset.productId = p.id;
            link.innerHTML = [
              '<div class="flex gap-2">',
              '  <img loading="lazy" alt="' + (p.title || 'Product') + '" class="w-10 h-10 object-cover rounded flex-shrink-0" src="' + (p.image || '') + '">',
              '  <div class="flex-1 min-w-0">',
              '    <div class="font-semibold text-xs line-clamp-2">' + (p.title || '') + '</div>',
              '    <div class="text-xs text-[#C2410C] font-bold mt-0.5">' + (p.price || '?') + ' ' + CFG.shopCurrency + '</div>',
              '  </div>',
              '</div>'
            ].join('');
            link.addEventListener('click', ev => {
              ev.preventDefault();
              track('vw_equipment_click', {
                rule_id: a.rule_id,
                trigger: trig,
                product_id: p.id,
                value: vwPriceNum(p.price)
              });
              window.location.href = link.href;
            });
            grid.appendChild(link);
          });
          card.appendChild(equipDiv);
        }
      }

      frag.appendChild(card);
    });



    root.innerHTML = '';
    root.appendChild(frag);

    // Klantvijvers-kaart (16-10-2026, opdracht Kees): staat alles op groen, dan is
    // dit het moment om de vijver te laten zien. Aan/uit en tegoed komen uit de
    // theme-instellingen via data-vw-kv-* op #vw-advies-cards.
    try { renderKlantvijversKaart(root, advice); } catch (_) {}

    // B9 (audit 2026-05-24): bij een crisis (Noodprotocol-kaart aanwezig) is een
    // wand van 9 kaarten overweldigend voor een leek. Houd het Noodprotocol + de
    // top-3 prioriteitskaarten zichtbaar; klap de overige detailkaarten in onder
    // "Toon alle details". De inhoud blijft volledig beschikbaar, alleen rustiger.
    (function () {
      var hasCrisis = advice.some(function (a) { return a && a.rule_id === 'VW-NOOD'; });
      if (!hasCrisis) return;
      var cards = Array.prototype.slice.call(root.querySelectorAll('.vw-card'));
      var KEEP = 4; // Noodprotocol + 3 prioriteitskaarten
      if (cards.length <= KEEP) return;
      var details = document.createElement('details');
      details.className = 'vw-crisis-details mb-3 rounded-lg border border-gray-200';
      var summary = document.createElement('summary');
      summary.className = 'cursor-pointer list-none px-4 py-3 font-semibold text-navy text-sm select-none hover:bg-gray-50 rounded-lg';
      summary.textContent = 'Toon alle details (' + (cards.length - KEEP) + ' extra kaarten)';
      details.appendChild(summary);
      var wrap = document.createElement('div');
      wrap.className = 'px-1 pb-1';
      cards.slice(KEEP).forEach(function (c) { wrap.appendChild(c); });
      details.appendChild(wrap);
      root.insertBefore(details, cards[KEEP - 1].nextSibling);
    })();

    // "Waarom niet"-transparantie: respons-breed kader onder de kaarten.
    var suppressed = (response && response.data && response.data.suppressed_notes) || [];
    if (suppressed.length) {
      var sBox = document.createElement('section');
      sBox.className = 'vw-suppressed text-small italic text-slate-600 border-l-4 border-slate-300 bg-slate-50 rounded-r px-3 py-2 mt-4';
      sBox.setAttribute('data-vw-component', 'suppressed-notes');
      // P2-4 (audit 2026-05-24): bij een rode kaart blijft deze veiligheidsuitleg
      // ook in Eenvoudig-modus zichtbaar (veiligheidskritisch).
      // Rode kaart -> veiligheidskritisch. A6 (audit 2026-05-24): ook een
      // fosfaatbinder-"niet nodig"-uitleg blijft in Eenvoudig zichtbaar
      // (waardeklant wil weten waarom hij iets NIET hoeft te kopen).
      var keepInSimple = advice.some(function(a){ return a && a.urgency === 'rood'; }) ||
        suppressed.some(function(n){ return n && /phosphate|fosfaat/i.test((n.type||'') + ' ' + (n.reason_nl||'')); });
      if (keepInSimple) {
        sBox.setAttribute('data-vw-safety-critical', '1');
      }
      var sLis = suppressed.map(function(n){ return '<li>' + escapeHtml(n && n.reason_nl || '') + '</li>'; }).join('');
      sBox.innerHTML = '<p class="font-semibold not-italic text-navy mb-1">Bewust niet geadviseerd:</p><ul class="list-disc pl-5 space-y-1">' + sLis + '</ul>';
      root.appendChild(sBox);
    }

    // ─── Keyword auto-link (Agent 4, 2026-05-26) ───────────────────
    // Linkt eerste voorkomen van bekend product-concept naar de juiste
    // collectie. Skipt anchors, headings, buttons, code, .vw-product
    // (data-vw-product). Implementatie in assets/vijvercheck-keyword-linker.js
    try {
      if (window.VijverCheck && typeof window.VijverCheck.linkKeywords === 'function') {
        window.VijverCheck.linkKeywords(root);
      }
    } catch (e) { /* keyword-link nooit blokkerend voor advies-render */ }

    track('vw_advice_viewed', {
      advice_count: advice.length,
      urgencies: advice.map(a => a.urgency),
      rule_ids: advice.map(a => a.rule_id)
    });
  }

  // Laatst bekende geocode, gebruikt om /forecast opnieuw op te halen wanneer
  // de gebruiker later zijn diepte invult, zodat pond_temp_forecast wordt
  // herberekend zonder een volledige /advice-roundtrip.
  const forecastState = { lat: null, lon: null, lastDepthCm: null };

  // Inline SVG's voor de weertegels (geen emoji, UI-richtlijn 16-10-2026).
  const VW_SVG_DROP = '<svg class="inline-block w-3 h-3 -mt-0.5 text-aqua" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z"/></svg>';
  const VW_SVG_WATER = '<svg class="inline-block w-3 h-3 -mt-0.5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0z"/></svg>';

  function updateForecastSubtitle(depthCm) {
    const el = $('#vw-forecast-subtitle');
    if (!el) return;
    if (typeof depthCm === 'number' && depthCm > 0) {
      const tpl = el.getAttribute('data-with-depth') || '';
      el.textContent = tpl.replace('{depth}', String(Math.round(depthCm)));
    } else {
      el.textContent = el.getAttribute('data-default') || el.textContent;
    }
  }

  // Inline fallback markup, moet 1-op-1 corresponderen met
  // snippets/vw-forecast-fallback.liquid. Twee modi: 'unavailable' / 'stale'.
  function buildForecastFallback(mode, hoursAgo) {
    var wrap = document.createElement('div');
    wrap.className = 'bg-koilight/30 border border-koilight rounded-xl p-4 text-sm text-navy';
    wrap.setAttribute('role', 'status');
    if (mode === 'stale') {
      wrap.setAttribute('data-vw-component', 'forecast-stale');
      var t1 = document.createElement('p');
      t1.className = 'font-semibold mb-1';
      t1.textContent = 'Weer-voorspelling iets verouderd';
      var t2 = document.createElement('p');
      var h = (typeof hoursAgo === 'number' && hoursAgo >= 0) ? String(Math.round(hoursAgo)) : '?';
      t2.textContent = 'Laatste weermeting ' + h + ' uur geleden, toch weergegeven voor context. Je advies werkt gewoon door op postcode, locatie en watertest.';
      wrap.appendChild(t1);
      wrap.appendChild(t2);
    } else {
      wrap.setAttribute('data-vw-component', 'forecast-unavailable');
      var u1 = document.createElement('p');
      u1.className = 'font-semibold mb-1';
      u1.textContent = 'Weer 7 dagen tijdelijk niet beschikbaar';
      var u2 = document.createElement('p');
      u2.textContent = 'Je advies werkt gewoon door op postcode, locatie en eventuele watertest.';
      wrap.appendChild(u1);
      wrap.appendChild(u2);
    }
    return wrap;
  }

  function renderForecast(response) {
    const root = $('#vw-forecast-tiles');
    if (!root || !response || !response.data) return;
    const d = response.data;
    const source = d.source || (d.forecast && d.forecast.source);
    const isStale = (d.is_stale === true) || (d.forecast && d.forecast.is_stale === true);
    const fetchedAt = d.fetched_at || (d.forecast && d.forecast.fetched_at);
    const { daily_temp = [], pond_temp_forecast = [], pond_model = null, latitude = null, longitude = null } = d;

    // ─── Unavailable: render fallback en stop ────────────────────────
    if (source === 'unavailable' || !Array.isArray(daily_temp) || daily_temp.length === 0) {
      root.innerHTML = '';
      root.appendChild(buildForecastFallback('unavailable'));
      var tilesEmpty = $('#vw-tiles');
      if (tilesEmpty) {
        tilesEmpty.innerHTML = '';
        tilesEmpty.appendChild(buildForecastFallback('unavailable').cloneNode(true));
        tilesEmpty.setAttribute('aria-busy', 'false');
      }
      try { track('vw_forecast_unavailable', { source: source || 'empty' }); } catch (_) {}
      return;
    }

    // Cache lat/lon + depth voor toekomstige depth-triggered re-fetch
    if (typeof latitude === 'number' && typeof longitude === 'number') {
      forecastState.lat = latitude;
      forecastState.lon = longitude;
    }
    // 2026-05-27: auto-refetch als forecast verdacht kort is (cache-corruptie defense)
    if (daily_temp.length < 7 && typeof latitude === 'number' && typeof longitude === 'number') {
      try { track('vw_forecast_short_refetch', { had_days: daily_temp.length }); } catch (_) {}
      vwApi.forecast(latitude, longitude, 7, pond_model && pond_model.depth_cm)
        .then(function(fr) {
          if (fr && fr.ok && fr.data && Array.isArray(fr.data.daily_temp) && fr.data.daily_temp.length > daily_temp.length) {
            renderForecast({ data: fr.data });
          }
        })
        .catch(function() {});
    }
    if (pond_model && typeof pond_model.depth_cm === 'number') {
      forecastState.lastDepthCm = pond_model.depth_cm;
      updateForecastSubtitle(pond_model.depth_cm === 100 ? null : pond_model.depth_cm);
    }

    // Agent B refactor 2026-05-27: default 4 tegels (vandaag + 3); 'Toon alle 7 dagen' expand.
    var FORECAST_KEY = 'vw_forecast_expanded_v1';
    var _wantAll = false;
    try { _wantAll = localStorage.getItem(FORECAST_KEY) === '1'; } catch (_) {}
    var DEFAULT_DAYS = 7;  // was 4, gewijzigd 2026-05-27: titel zegt 7 dus toon 7 direct
    var grid = document.createElement('div');
    grid.className = 'grid grid-cols-4 md:grid-cols-7 gap-2';
    grid.setAttribute('data-vw-forecast-grid', '');
    function _buildTile(day, i) {
      var card = document.createElement('div');
      card.className = 'text-center p-3 border border-slate-200 rounded-lg bg-gradient-to-b from-koilight/20 to-white';
      card.innerHTML = [
        '<div class="text-xs font-semibold text-slate-700 mb-1">' + formatDate(Date.now() + i * 86400000, 'weekday-short') + '</div>',
        '<div class="text-base font-bold text-navy">' + (day.temp_max || 0) + '°</div>',
        '<div class="text-xs text-slate-600">' + (day.temp_min || 0) + '° / ' + VW_SVG_DROP + ' ' + (day.rain_mm || 0) + 'mm</div>',
        '<div class="text-xs text-[#C2410C] font-semibold mt-1" title="Verwachte vijvertemperatuur">' + VW_SVG_WATER + ' ' + (pond_temp_forecast[i] || '?') + '°</div>'
      ].join('');
      return card;
    }
    var _initialCount = _wantAll ? 7 : DEFAULT_DAYS;
    daily_temp.slice(0, _initialCount).forEach(function (day, i) { grid.appendChild(_buildTile(day, i)); });

    root.innerHTML = '';
    root.appendChild(grid);

    if (daily_temp.length > DEFAULT_DAYS) {
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'vw-forecast-toggle mt-3 inline-flex items-center gap-1 text-sm font-semibold text-aqua-donker min-h-[44px] px-2 -mx-2 focus-visible:ring-brand-focus';
      toggle.setAttribute('aria-expanded', _wantAll ? 'true' : 'false');
      toggle.innerHTML = (_wantAll ? 'Toon minder dagen ' : 'Toon alle 7 dagen ')
        + '<svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>';
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        var next = !open;
        toggle.setAttribute('aria-expanded', next ? 'true' : 'false');
        try { localStorage.setItem(FORECAST_KEY, next ? '1' : '0'); } catch (_) {}
        var existing = grid.querySelectorAll('div');
        existing.forEach(function (n) { n.remove(); });
        var cnt = next ? 7 : DEFAULT_DAYS;
        daily_temp.slice(0, cnt).forEach(function (day, i) { grid.appendChild(_buildTile(day, i)); });
        toggle.firstChild.nodeValue = next ? 'Toon minder dagen ' : 'Toon alle 7 dagen ';
        try { track('vw_forecast_toggle', { expanded: next }); } catch (_) {}
      });
      root.appendChild(toggle);
    }

    // ─── Stale-label: forecast werkt maar is oud (>X uur) ──────────
    if (isStale) {
      var hoursAgo = null;
      if (fetchedAt) {
        var t = (typeof fetchedAt === 'number') ? fetchedAt * (fetchedAt < 1e12 ? 1000 : 1) : Date.parse(fetchedAt);
        if (!isNaN(t)) hoursAgo = Math.max(0, (Date.now() - t) / 3600000);
      }
      var staleEl = buildForecastFallback('stale', hoursAgo);
      staleEl.classList.add('mt-2');
      root.appendChild(staleEl);
      try { track('vw_forecast_stale', { hours_ago: hoursAgo }); } catch (_) {}
    }

    // Fill hero tiles (compact 3-day strip) if present
    const tiles = $('#vw-tiles');
    if (tiles) {
      tiles.innerHTML = '';
      daily_temp.slice(0, 3).forEach((day, i) => {
        const t = document.createElement('div');
        t.className = 'text-center p-2 rounded-lg bg-koilight/30 border border-slate-200';
        t.innerHTML = [
          '<div class="text-[10px] font-semibold text-slate-700">' + formatDate(Date.now() + i * 86400000, 'weekday-short') + '</div>',
          '<div class="text-sm font-bold text-navy">' + (day.temp_max || 0) + '°</div>',
          '<div class="text-[10px] text-[#C2410C] font-semibold" title="Verwachte vijvertemperatuur">' + VW_SVG_WATER + ' ' + (pond_temp_forecast[i] || '?') + '°</div>'
        ].join('');
        tiles.appendChild(t);
      });
      tiles.setAttribute('aria-busy', 'false');
    }
  }

  // ──────────────────────────────────────────────────────────────
  // Agent 3 (PRODUCT) 2026-05-27: ATC vanuit cross-sell-kaarten.
  // Resolve variant via /products/<handle>.js (cached), POST naar
  // /cart/add.js, spinner-state, success-state, toast met "Bekijk
  // mandje"-link, dispatch cart:refresh + cart-badge bump.
  // ──────────────────────────────────────────────────────────────
  var __vwVariantCache = Object.create(null);

  function vwResolveFirstVariant(handle) {
    if (!handle) return Promise.reject(new Error('no-handle'));
    if (__vwVariantCache[handle]) return Promise.resolve(__vwVariantCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function (data) {
      var vars = (data && data.variants) || [];
      var first = vars.find(function (v) { return v && v.available; }) || vars[0] || null;
      if (!first) throw new Error('no-variant');
      __vwVariantCache[handle] = first.id;
      return first.id;
    });
  }

  function vwSetAtcState(btn, state) {
    if (!btn) return;
    var label = btn.querySelector('[data-atc-label]');
    if (!label) return;
    if (state === 'loading') {
      btn.disabled = true;
      btn.classList.remove('bg-green-600', 'hover:bg-green-700');
      btn.classList.add('bg-koi');
      label.innerHTML = '<svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>Bezig...';
    } else if (state === 'success') {
      btn.disabled = false;
      btn.classList.remove('bg-koi', 'hover:bg-orange-800');
      btn.classList.add('bg-green-600', 'hover:bg-green-700');
      label.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>Toegevoegd';
    } else if (state === 'error') {
      btn.disabled = false;
      btn.classList.remove('bg-green-600', 'hover:bg-green-700');
      btn.classList.add('bg-koi', 'hover:bg-orange-800');
      label.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>Probeer opnieuw';
    } else { // idle
      btn.disabled = false;
      btn.classList.remove('bg-green-600', 'hover:bg-green-700');
      btn.classList.add('bg-koi', 'hover:bg-orange-800');
      label.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"/></svg>In mandje';
    }
  }

  function vwBumpCartBadge(n) {
    try {
      var nodes = document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count, [data-header-cart-count]');
      nodes.forEach(function (el) {
        var cur = parseInt(el.textContent, 10);
        if (!isNaN(cur)) el.textContent = String(cur + n);
      });
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      // Shopify Dawn-stijl event
      document.dispatchEvent(new CustomEvent('cart:item-added'));
    } catch (_) {}
  }

  function vwToastWithCartLink(msg) {
    var host = document.getElementById('vw-toast-host');
    if (!host) {
      host = document.createElement('div');
      host.id = 'vw-toast-host';
      host.setAttribute('aria-live', 'polite');
      host.setAttribute('aria-atomic', 'true');
      host.style.cssText = 'position:fixed;z-index:300;bottom:16px;left:50%;transform:translateX(-50%);display:flex;flex-direction:column;gap:8px;pointer-events:none;max-width:min(420px, calc(100vw - 24px));width:100%;padding:0 12px;';
      document.body.appendChild(host);
    }
    var el = document.createElement('div');
    el.style.cssText = 'pointer-events:auto;background:#0B1E36;color:#fff;padding:12px 14px;border-radius:12px;box-shadow:0 8px 24px rgba(0,0,0,.22);font-size:14px;display:flex;align-items:center;gap:10px;justify-content:space-between;animation:vwToastIn .25s ease-out;';
    el.innerHTML = '<span style="display:inline-flex;align-items:center;gap:8px;flex:1;min-width:0;">'
      + '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#34d399" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>'
      + '<span style="overflow:hidden;text-overflow:ellipsis;">' + msg + '</span>'
      + '</span>'
      + '<a href="/cart" style="flex-shrink:0;color:#5eead4;text-decoration:underline;font-weight:600;white-space:nowrap;">Bekijk mandje</a>';
    host.appendChild(el);
    setTimeout(function () { try { el.style.opacity = '0'; el.style.transition = 'opacity .3s'; } catch (_) {} }, 3500);
    setTimeout(function () { try { el.remove(); } catch (_) {} }, 4000);
  }

  function vwAtcFromCrossSell(btn) {
    if (!btn || btn.disabled) return;
    var handle = btn.getAttribute('data-product-handle');
    var pid = btn.getAttribute('data-product-id');
    var price = vwPriceNum(btn.getAttribute('data-product-price'));
    var rule_id = btn.getAttribute('data-rule-id') || '';
    var trigger = btn.getAttribute('data-trigger') || '';
    var startTs = Date.now();

    vwSetAtcState(btn, 'loading');

    vwResolveFirstVariant(handle)
      .then(function (variantId) {
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('cart-' + r.status);
        return r.json();
      })
      .then(function () {
        var elapsed = Date.now() - startTs;
        var wait = Math.max(0, 500 - elapsed); // min 0.5s spinner visible
        setTimeout(function () {
          vwSetAtcState(btn, 'success');
          vwToastWithCartLink('Toegevoegd aan winkelmandje');
          vwBumpCartBadge(1);
          try {
            track('vw_add_to_cart', {
              rule_id: rule_id,
              trigger: trigger,
              product_id: pid,
              value: price,
              origin: 'crosssell'
            });
          } catch (_) {}
          setTimeout(function () { vwSetAtcState(btn, 'idle'); }, 2000);
        }, wait);
      })
      .catch(function (err) {
        console.warn('[vw-atc] failed:', err);
        vwSetAtcState(btn, 'error');
        vwToastWithCartLink('Niet gelukt om toe te voegen. Probeer opnieuw.');
        setTimeout(function () { vwSetAtcState(btn, 'idle'); }, 2500);
      });
  }

  function renderCrossSell(response) {
    var sectionOuter = $('#vw-crosssell');
    var section = sectionOuter; // backward-compat met legacy block
    const grid = $('#vw-crosssell-grid');
    if (!section || !grid || !response || !response.data) return;
    const { product_suggestions = {}, advice = [] } = response.data;
    // B5 (audit 2026-05-24): rol per product (Nu nodig / Herstel / Optioneel)
    // op basis van de urgentie van de kaart waar het product bij hoort.
    const ruleUrgency = {};
    advice.forEach(function(a){ if (a && a.rule_id) ruleUrgency[a.rule_id] = a.urgency; });

    // Verzamel producten uit alle triggers in volgorde van urgentie,
    // daarna dedupe op URL-handle (betrouwbaarder dan p.id: varianten
    // hebben soms verschillende id's maar dezelfde product-handle).
    const urgencyOrder = { rood: 0, oranje: 1, geel: 2, groen: 3 };
    const sorted = advice.slice().sort((a, b) =>
      (urgencyOrder[a.urgency] ?? 4) - (urgencyOrder[b.urgency] ?? 4)
    );
    const candidates = [];
    sorted.forEach(a => {
      (a.triggers || []).forEach(trig => {
        (product_suggestions[trig] || []).forEach(p => {
          if (p) candidates.push({ product: p, trigger: trig, rule_id: a.rule_id });
        });
      });
    });
    const items = uniqueProducts(candidates);

    if (items.length === 0) {
      grid.innerHTML = '';
      section.hidden = true;
      return;
    }

    grid.innerHTML = '';
    grid.className = 'space-y-6';
    const meerdere = items.length > 1;
    // Agent B refactor 2026-05-27: groepeer per rol (Nu nodig / Herstel / Optioneel),
    // toon per groep een heading + horizontaal-snap-rij op mobile.
    var _vwSliced = items.slice(0, 9);
    var _buckets = { 'Nu nodig': [], 'Herstel': [], 'Optioneel': [] };
    _vwSliced.forEach(function (it) {
      var p = it.product || {};
      var _u = ruleUrgency[it.rule_id] || 'geel';
      var _isBact = /bacter|starter|nitrif|filterbacter/i.test(p.title || '');
      var _isSecondary = /ma[eë]rl|algisin|algendoder|algae\s*kill|anti[- ]?alg/i.test(p.title || '');
      var _role = _isBact ? 'Herstel'
        : (_isSecondary ? 'Optioneel'
        : ((_u === 'rood' || _u === 'oranje') ? 'Nu nodig' : 'Optioneel'));
      it._role = _role;
      _buckets[_role].push(it);
    });

    var _bucketTitles = {
      'Nu nodig': { icon: '<svg class="inline-block w-5 h-5 -mt-0.5 text-aqua" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>', label: 'Nu nodig voor jouw vijver' },
      'Herstel': { icon: '<svg class="inline-block w-5 h-5 -mt-0.5 text-aqua" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 20h10"/><path d="M10 20c5.5-2.5.8-6.4 3-10"/><path d="M9.5 9.4c1.1.8 1.8 2.2 2.3 3.7-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2 2.8-.5 4.4 0 5.5.8z"/><path d="M14.1 6a7 7 0 0 0-1.1 4c1.9-.1 3.3-.6 4.3-1.4 1-1 1.6-2.3 1.7-4.6-2.7.1-4 1-4.9 2z"/></svg>', label: 'Herstel & opbouw' },
      'Optioneel': { icon: '<svg class="inline-block w-5 h-5 -mt-0.5 text-aqua" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"/><path d="M9 18h6"/><path d="M10 22h4"/></svg>', label: 'Optioneel / handig om te hebben' }
    };
    ['Nu nodig', 'Herstel', 'Optioneel'].forEach(function (roleKey) {
      var arr = _buckets[roleKey];
      if (!arr.length) return;
      var meta = _bucketTitles[roleKey];
      var section = document.createElement('section');
      section.setAttribute('data-vw-prod-bucket', roleKey);
      var h = document.createElement('h3');
      h.className = 'font-display font-semibold text-base text-navy mb-2 flex items-center gap-2';
      h.innerHTML = '<span aria-hidden="true">' + meta.icon + '</span> ' + meta.label + ' <span class="text-xs font-normal text-slate-500">(' + arr.length + ')</span>';
      section.appendChild(h);
      var row = document.createElement('div');
      row.className = 'vw-prod-row';
      arr.forEach(function (it) {
        var p = it.product || {};
        var trigger = it.trigger;
        var rule_id = it.rule_id;
        var _role = it._role;
        var _roleCls = _role === 'Nu nodig' ? 'bg-red-600 text-white'
          : (_role === 'Herstel' ? 'bg-orange-500 text-white' : 'bg-slate-200 text-slate-700');
        var _inStock = p.in_stock !== false;
        var _soldOut = !_inStock
          ? ('<div class="text-[11px] font-semibold text-amber-700 mt-1">Tijdelijk uitverkocht' + (meerdere ? ' - zie alternatieven' : '') + '</div>')
          : '';
        var pUrl = preserveUtm(p.url || '#');
        var pHandle = p.handle || (function(){
          if (!p.url) return '';
          var m = String(p.url).match(/\/products\/([^?#\/]+)/);
          return m ? m[1] : '';
        })();
        var card = document.createElement('article');
        card.className = 'group vw-prod-card relative flex flex-col bg-white rounded-xl border border-slate-200 overflow-hidden transition-all duration-200 hover:shadow-md hover:-translate-y-0.5 hover:border-aqua';
        if (p.id != null) card.dataset.productId = p.id;
        if (pHandle) card.dataset.productHandle = pHandle;

        // CTA-button HTML: ATC voor in-stock, anders "Bekijk product"
        var btnHtml;
        if (_inStock && pHandle) {
          btnHtml = '<button type="button" data-vw-prod-atc data-product-handle="' + pHandle + '" data-product-id="' + (p.id || '') + '" data-product-price="' + (vwPriceNum(p.price)) + '" data-rule-id="' + (rule_id || '') + '" data-trigger="' + (trigger || '') + '" class="vw-prod-atc mt-auto w-full min-h-[40px] inline-flex items-center justify-center gap-1.5 bg-koi text-white font-semibold text-sm rounded-lg px-3 py-2 hover:bg-orange-800 transition-colors disabled:opacity-70 disabled:cursor-wait">'
            + '<span data-atc-label class="inline-flex items-center gap-1.5"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"/></svg>In mandje</span>'
            + '</button>';
        } else {
          btnHtml = '<a href="' + pUrl + '" rel="noopener" data-vw-prod-link class="mt-auto w-full min-h-[40px] inline-flex items-center justify-center gap-1.5 bg-navy text-white font-semibold text-sm rounded-lg px-3 py-2 hover:bg-navy/90 transition-colors no-underline">Bekijk product</a>';
        }

        card.innerHTML = [
          // Foto bovenin (16:10, object-cover)
          '<a href="' + pUrl + '" rel="noopener" data-vw-prod-link class="relative block aspect-[16/10] overflow-hidden bg-slate-50">',
          '  <span class="absolute top-2 left-2 z-10 inline-flex items-center text-[10px] font-bold uppercase tracking-wide rounded-full px-2 py-1 shadow-sm ' + _roleCls + '">' + _role + '</span>',
          (p.image
            ? '  <img loading="lazy" alt="' + (p.title || 'Product') + '" src="' + (p.image) + '" class="absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-105">'
            : '  <span class="absolute inset-0 flex items-center justify-center text-slate-500 text-xs">geen foto</span>'),
          '</a>',
          // Body
          '<div class="flex flex-col flex-1 gap-1.5 p-3">',
          '  <a href="' + pUrl + '" rel="noopener" data-vw-prod-link class="font-semibold text-navy text-sm leading-snug line-clamp-2 min-h-[2.4em] no-underline hover:text-aqua-donker transition-colors">' + (p.title || '') + '</a>',
          '  <div class="text-koi font-bold text-base leading-none">' + (p.price || '?') + ' ' + CFG.shopCurrency + '</div>',
          '  <div class="text-[11px] text-slate-500 leading-tight">Past bij ' + humanizeTrigger(trigger) + '</div>',
          _soldOut,
          btnHtml,
          '</div>'
        ].join('');

        // Klik op foto/titel/link -> track + ga naar PDP
        card.querySelectorAll('[data-vw-prod-link]').forEach(function (el) {
          el.addEventListener('click', function (ev) {
            ev.preventDefault();
            track('vw_product_click', {
              rule_id: rule_id,
              trigger: trigger,
              product_id: p.id,
              value: vwPriceNum(p.price),
              origin: 'crosssell'
            });
            window.location.href = el.getAttribute('href');
          });
        });

        // ATC-knop
        var atcBtn = card.querySelector('[data-vw-prod-atc]');
        if (atcBtn) {
          atcBtn.addEventListener('click', function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            vwAtcFromCrossSell(atcBtn);
          });
        }

        row.appendChild(card);
      });
      section.appendChild(row);
      grid.appendChild(section);
    });

    sectionOuter.hidden = false;
    return;

    // Legacy single-grid render (unreachable, kept for reference):
    items.slice(0, 6).forEach(({ product: p, trigger, rule_id }) => {
      const link = document.createElement('a');
      link.className = 'block bg-white rounded-xl border border-slate-200 p-4 hover:border-aqua hover:shadow-soft transition-all no-underline';
      link.href = preserveUtm(p.url || '#');
      link.rel = 'noopener';
      link.dataset.productId = p.id;
      // B5: rol-label. Nitrificerende bacterie = herstel; rood/oranje kaart = nu nodig; rest = optioneel.
      const _u = ruleUrgency[rule_id] || 'geel';
      const _isBact = /bacter|starter|nitrif|filterbacter/i.test(p.title || '');
      // Functionele audit 2026-05-25: tragere/secundaire of voorzichtig-te-gebruiken
      // middelen (gecombineerde KH/GH-buffer zoals Maerl, chemische algendoder) nooit
      // als "Nu nodig" labelen, die zijn een optionele/aanvullende keuze.
      const _isSecondary = /ma[eë]rl|algisin|algendoder|algae\s*kill|anti[- ]?alg/i.test(p.title || '');
      const _role = _isBact ? 'Herstel'
        : (_isSecondary ? 'Optioneel'
        : ((_u === 'rood' || _u === 'oranje') ? 'Nu nodig' : 'Optioneel'));
      const _roleCls = _role === 'Nu nodig' ? 'bg-red-100 text-red-800'
        : (_role === 'Herstel' ? 'bg-amber-100 text-amber-800' : 'bg-slate-100 text-slate-600');
      const _soldOut = p.in_stock === false
        ? ('    <div class="text-xs font-semibold text-amber-700 mt-1">Tijdelijk uitverkocht, wel het juiste product' + (meerdere ? '; zie de alternatieven hieronder' : '') + '</div>')
        : '';
      link.innerHTML = [
        '<div class="flex gap-3">',
        '  <img loading="lazy" alt="' + (p.title || 'Product') + '" class="w-20 h-20 object-cover rounded-lg flex-shrink-0" src="' + (p.image || '') + '">',
        '  <div class="flex-1 min-w-0">',
        '    <span class="inline-block text-[10px] font-bold rounded px-1.5 py-0.5 mb-1 ' + _roleCls + '">' + _role + '</span>',
        '    <div class="font-semibold text-navy text-sm leading-snug line-clamp-2">' + (p.title || '') + '</div>',
        '    <div class="text-[#C2410C] font-bold text-base mt-1">' + (p.price || '?') + ' ' + CFG.shopCurrency + '</div>',
        _soldOut,
        '    <div class="text-xs text-slate-500 mt-1">Past bij: ' + humanizeTrigger(trigger) + '</div>',
        '  </div>',
        '</div>'
      ].join('');
      link.addEventListener('click', ev => {
        ev.preventDefault();
        track('vw_product_click', {
          rule_id: rule_id,
          trigger: trigger,
          product_id: p.id,
          value: vwPriceNum(p.price),
          origin: 'crosssell'
        });
        window.location.href = link.href;
      });
      grid.appendChild(link);
    });

    section.hidden = false;
  }

  // ──────────────────────────────────────────────────────────────
  // "BEKIJK OOK": GLOBAL COLLECTION LINKS
  //
  // Naast product-crosssell willen we klanten ook door-routeren naar
  // de bredere klant-zichtbare collecties (zodat ze zélf verder kunnen
  // zoeken als het gesuggereerde product net niet past). Server levert
  // `response.data.collection_links[trigger]` = [{handle, url}, …] met
  // app_*-handles al uitgefilterd in advice/index.ts (lines 316-333).
  //
  // Ontwerp-keuze (Kees 2026-04-17):
  //   - één globale strook, niet per-card (minimaliseert visuele ruis)
  //   - max 3 links (klant kiest makkelijk, CTR hoger dan bij 6+)
  //   - minimalistisch (geen iconen, geen lange sub-copy, rustige regel)
  //   - plek: onder #vw-crosssell (dus na de producten, als verdieping)
  //
  // Scoring: urgency-gewogen frequentie. Rode adviezen wegen zwaarder
  // zodat collecties die relevant zijn bij crises bovenaan staan. Bij
  // gelijke scores valt alfabetische handle-sort door (stabiel voor QA).
  //
  // Fallback: als geen triggers gevuurd → 3 evergreen defaults
  // (watertests, onderhoud, voer) zodat de strook niet leeg oogt bij
  // een groen advies. Klant ziet nooit een "broken" sectie.
  // ──────────────────────────────────────────────────────────────
  const COLLECTION_FALLBACK = Object.freeze([
    { handle: 'water-testen-meten', url: '/collections/water-testen-meten' },
    { handle: 'waterkwaliteit-onderhoud',  url: '/collections/waterkwaliteit-onderhoud'  },
    { handle: 'koivoer-basis',             url: '/collections/koivoer-basis'             }
  ]);

  function renderCollectionLinks(response) {
    const section = $('#vw-collections');
    const grid = $('#vw-collections-grid');
    if (!section || !grid) return;

    const data = (response && response.data) || {};
    const collectionLinks = data.collection_links || {};
    const advice = data.advice || [];

    // Score per handle: urgency-gewogen frequency. Bij ties alfabetisch.
    const urgencyWeight = { rood: 4, oranje: 3, geel: 2, groen: 1 };
    const scores = new Map();
    advice.forEach(a => {
      const w = urgencyWeight[a.urgency] != null ? urgencyWeight[a.urgency] : 1;
      (a.triggers || []).forEach(trig => {
        const links = collectionLinks[trig] || [];
        links.forEach(link => {
          if (!link || !link.handle) return;
          // Extra safety; server filtert al op app_*, maar dubbelop belast niets.
          if (String(link.handle).startsWith('app_')) return;
          const prev = scores.get(link.handle) || { score: 0, url: link.url || '/collections/' + link.handle };
          prev.score += w;
          scores.set(link.handle, prev);
        });
      });
    });

    let top = Array.from(scores.entries())
      .sort((a, b) => b[1].score - a[1].score || a[0].localeCompare(b[0]))
      .slice(0, 3);

    if (top.length === 0) {
      top = COLLECTION_FALLBACK.map(f => [f.handle, { score: 0, url: f.url }]);
    }

    grid.innerHTML = '';
    top.forEach(entry => {
      const handle = entry[0];
      const url = (entry[1] && entry[1].url) || ('/collections/' + handle);
      const label = humanizeCollection(handle);
      const link = document.createElement('a');
      link.className = 'group flex items-center justify-between gap-4 bg-white rounded-xl border border-slate-200 px-4 py-3 hover:border-aqua hover:shadow-soft transition-all no-underline focus-visible:ring-brand-focus';
      link.href = preserveUtm(url);
      link.rel = 'noopener';
      link.dataset.vwCollection = handle;
      link.innerHTML = [
        '<span class="min-w-0 flex-1">',
        '  <span class="block font-semibold text-navy text-sm leading-snug group-hover:text-aqua-donker">' + escapeHtml(label.title) + '</span>',
        label.sub ? '  <span class="block text-xs text-slate-500 mt-0.5">' + escapeHtml(label.sub) + '</span>' : '',
        '</span>',
        '<span class="inline-flex items-center gap-1 text-[#0F766E] font-semibold text-xs flex-shrink-0">',
        '  Bekijk',
        '  <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>',
        '</span>'
      ].join('');
      link.addEventListener('click', () => {
        track('vw_collection_click', { handle: handle, origin: 'bekijk_ook' });
      });
      grid.appendChild(link);
    });

    section.hidden = false;
  }

  // ──────────────────────────────────────────────────────────────
  // ORCHESTRATION
  // ──────────────────────────────────────────────────────────────
  async function runAdvice(ctx) {
    const widget = $('#vw-widget');
    if (widget) widget.setAttribute('aria-busy', 'true');
    const loc = $('#vw-loc');
    if (loc) loc.textContent = 'Advies ophalen…';

    // P0-1 (audit 2026-05-24, B1): reset alle resultaatzones VOOR de nieuwe
    // berekening, anders blijft productadvies van een vorig scenario staan.
    ['#vw-crosssell', '#vw-collections'].forEach(function (sel) {
      var s = $(sel); if (s) s.hidden = true;
    });
    ['#vw-crosssell-grid', '#vw-collections-grid'].forEach(function (sel) {
      var g = $(sel); if (g) g.innerHTML = '';
    });

    track('vw_advice_requested', { postcode: ctx.location && ctx.location.postcode });
    // Direct fire-and-forget POST (audit 2026-05-27): voorkomt event-verlies van beforeunload-flush op mobile,
    // anoniem (alleen postcode + session_id), geen PII.
    try {
      var _vcEvBody = JSON.stringify({
        name: 'vw_advice_requested',
        session_id: (typeof getOrCreateSessionId === 'function') ? getOrCreateSessionId() : null,
        properties: { postcode: ctx.location && ctx.location.postcode, has_meas: !!(ctx.measurements && Object.keys(ctx.measurements).length) }
      });
      fetch(CFG.apiBaseUrl.replace(/\/+$/, '') + '/events', {
        method: 'POST', mode: 'cors', credentials: 'omit',
        headers: { 'Content-Type': 'application/json' },
        body: _vcEvBody,
        keepalive: true
      }).catch(function(){});
    } catch (_) {}

    const res = await vwApi.advice(Object.assign({ context_version: 1 }, ctx));

    if (widget) widget.setAttribute('aria-busy', 'false');

    if (!res.ok) {
      track('vw_advice_error', { status: res.status, codes: (res.errors || []).map(e => e.code) });
      const cards = $('#vw-advies-cards');
      if (cards) {
        cards.innerHTML = '<div class="bg-red-50 border border-red-200 text-red-800 p-4 rounded-xl"><strong>Fout bij het ophalen van advies.</strong> Probeer het later opnieuw of mail <a href="mailto:service@vijvercentrum.nl" class="underline">service@vijvercentrum.nl</a>.</div>';
      }
      const tips = $('#vw-tips');
      if (tips) tips.innerHTML = '<div class="text-sm text-red-700">Advies niet beschikbaar. Probeer het later opnieuw.</div>';
      if (loc) loc.textContent = 'Advies tijdelijk niet beschikbaar.';
      // Smoke-test 19-08-2026: bij een gefaalde /advice bleef #vw-tiles op
      // aria-busy=true met nul tegels staan, dus draaide de laadindicator
      // eindeloos door naast de zichtbare foutmelding. renderForecast heeft
      // al een nette fallback, maar die wordt alleen bereikt als er een
      // antwoord binnenkomt. Deze tak haalt de tegelstrip uit de
      // laadtoestand zodat de bezoeker weet dat er niets meer komt.
      try {
        const tilesFail = $('#vw-tiles');
        if (tilesFail && tilesFail.children.length === 0) {
          tilesFail.appendChild(buildForecastFallback('unavailable'));
          tilesFail.setAttribute('aria-busy', 'false');
        }
        const forecastFail = $('#vw-forecast-tiles');
        if (forecastFail && forecastFail.children.length === 0) {
          forecastFail.appendChild(buildForecastFallback('unavailable'));
        }
        track('vw_forecast_unavailable', { source: 'advice-failed-' + res.status });
      } catch (_) {}
      return null;
    }

    // Render full advice + summary (renderAdviceCards calls renderAdviceSummary internally)
    try { window.__vwLastAdvice = res && res.data ? res.data : res; } catch(_){}
    try { window.__vwLastCtx = ctx; } catch(_){}
    // Progressive disclosure: het resultaat wordt pas zichtbaar na de eerste
    // geslaagde /advice, voor de render zodat IntersectionObservers en de
    // scroll naar #vw-results een zichtbaar element treffen.
    vwSetState('advies');
    renderAdviceCards(res);

    // Mobile sticky-CTA: nu er advies is, schakel over naar de
    // "Ga naar advies"-variant. Toont de klant nooit meer "Vul je
    // postcode in" terwijl die al advies ontvangen heeft, dat voelde
    // als een tool die het spoor kwijt is.
    const sticky = $('#vw-sticky-cta');
    if (sticky) {
      sticky.setAttribute('data-state', 'submitted');
      const initial = sticky.querySelector('[data-vw-sticky="initial"]');
      const submitted = sticky.querySelector('[data-vw-sticky="submitted"]');
      if (initial) initial.style.display = 'none';
      if (submitted) {
        // G (5-agent UX 2026-05-26): submitted CTA wijst vooruit naar
        // #vw-diagnose. Verberg als gebruiker watertest al ingevuld
        // heeft, dan is "verfijn met watertest" misleidend.
        let _hasDiag = false;
        try {
          const _raw = localStorage.getItem('vw_diagnose_v1');
          if (_raw) {
            const _d = JSON.parse(_raw) || {};
            const _m = _d.measurements || {};
            const _p = _d.pond || {};
            _hasDiag = ['ph','kh','gh','no2','no3','nh4','o2'].some(k => _m[k] != null && _m[k] !== '')
                    || ['volume_l','has_airpump','has_uvc','alg_type','filter_type','pump_lph','uvc_watt','uvc_lamp_months','fish_kg']
                         .some(k => (_d[k] != null && _d[k] !== '') || (_p[k] != null && _p[k] !== ''));
          }
        } catch (_) {}
        submitted.style.display = _hasDiag ? 'none' : '';
      }
    }

    // Forecast: kan als nested object (res.data.forecast) of als losse fields komen
    if (res.data) {
      if (res.data.forecast) {
        renderForecast({ data: res.data.forecast });
      } else if (res.data.daily_temp) {
        renderForecast(res);
      }
    }

    // Cross-sell: toon alleen als er producten zijn
    renderCrossSell(res);

    // /* vw-save-cta-hook */ VijverCheck Phase 1: notify save-CTA + history-listeners.
    try {
      document.dispatchEvent(new CustomEvent('vw:advice', { detail: { response: res, context: ctx } }));
    } catch (_e) { /* CustomEvent older browsers */ }


    // "Bekijk ook": globale collectie-strook onder crosssell. Altijd
    // zichtbaar (met fallback bij leeg advies), maar op basis van
    // gevuurde triggers: klant ziet de 3 collecties die écht aansluiten.
    renderCollectionLinks(res);

    if (loc) {
      const pc = (ctx.location && ctx.location.postcode) || '';
      // Plaatsnaam komt uit de advice-response (geocode-pass). res.data.location
      // is canonical; ctx.location alleen als user het zelf heeft meegegeven.
      // country dient als BE/NL-kwalifier bij dubbelzinnige plaatsnamen.
      const resolvedPlaats = (res.data && res.data.location && res.data.location.plaats)
        || (ctx.location && ctx.location.plaats) || '';
      const resolvedCountry = (res.data && res.data.location && res.data.location.country)
        || (ctx.location && ctx.location.country) || '';
      const where = resolvedPlaats
        ? (resolvedCountry === 'BE' ? resolvedPlaats + ' (BE, ' + pc + ')' : resolvedPlaats + ' (' + pc + ')')
        : (pc ? 'postcode ' + pc : '');
      const adv = (res.data && res.data.advice) || [];
      const n = adv.length;
      if (where && n === 0) {
        loc.textContent = 'Geen urgente meldingen voor ' + where + ' op basis van het weer. Vul je watertest in voor een persoonlijk advies.';
      } else if (where && n === 1) {
        loc.textContent = 'Advies voor ' + where + ': 1 aandachtspunt.';
      } else if (where) {
        loc.textContent = 'Advies voor ' + where + ': ' + n + ' aandachtspunten.';
      } else {
        loc.textContent = 'Advies bijgewerkt.';
      }
    }

    return res;
  }

  async function onSubscribe(email, extraProfile) {
    const res = await vwApi.subscribe({
      email, consent: {
        granted_at: new Date().toISOString(), source: 'vijvercheck-widget', method: 'explicit-form'
      },
      profile: Object.assign({}, extraProfile || {})
    });
    if (res.ok || res.status === 202) {
      track('vw_subscribe_ok', {});
    } else {
      track('vw_subscribe_error', { status: res.status });
    }
    return res;
  }

  // ──────────────────────────────────────────────────────────────
  // INIT
  // ──────────────────────────────────────────────────────────────
  function readDiagnoseValues(form) {
    const num = name => {
      const el = form.elements[name];
      if (!el) return undefined;
      // type=text met inputmode (03-10-2026): een komma wordt een punt, want type=number
      // las 7,5 als 75. Bij hele getallen (inputmode=numeric) zijn punten duizendtallen:
      // 12.000 liter = 12000.
      let v = String(el.value || '').trim().replace(/\s/g, '');
      if ((el.getAttribute('inputmode') || '') === 'numeric') v = v.replace(/\./g, '');
      v = v.replace(',', '.');
      if (v === '') return undefined;
      const n = parseFloat(v);
      if (!Number.isFinite(n)) return undefined;
      // Baymard-audit 2026-05-25: respecteer de min/max van het veld. Een waarde
      // buiten bereik (typefout of uit localStorage) niet meesturen -> voorkomt
      // een 400 + generieke "Fout bij het ophalen"-crash.
      var mn = el.min !== '' && el.min != null ? parseFloat(el.min) : null;
      var mx = el.max !== '' && el.max != null ? parseFloat(el.max) : null;
      if (mn !== null && Number.isFinite(mn) && n < mn) return undefined;
      if (mx !== null && Number.isFinite(mx) && n > mx) return undefined;
      return n;
    };
    // Form field names (lowercase: ph/kh/gh/no2/no3/nh4/o2) worden hier
    // vertaald naar de canonieke server-schema-keys (zie backend/_shared/
    // zod-schemas.ts MeasurementsSchema). Zod.strip() haalt unknown keys
    // weg, dus zonder deze mapping bereiken measurements nooit de engine.
    const raw = {
      pH: num('ph'),
      KH_dkh: num('kh'),
      GH_dkh: num('gh'),
      NO2_mg_l: num('no2'),
      NO3_mg_l: num('no3'),
      PO4_mg_l: num('po4'),
      NH4_total_mg_l: num('nh4'),
      O2_mg_l: num('o2')
    };
    const measurements = {};
    Object.keys(raw).forEach(k => { if (raw[k] !== undefined) measurements[k] = raw[k]; });
    const depth_cm = num('depth_cm');
    // Algtype (vrije-vorm observation; geen schema-bump).
    const observations = {};
    const atEl = form.elements['alg_type'];
    if (atEl && atEl.value) observations.alg_type = atEl.value;
    // Vijverprofiel (Sprint 3): alleen meesturen wat de klant expliciet invult.
    const pond = {};
    const vol = num('volume_l');
    // Audit 2026-05-25: alleen een volume binnen de geldige range meesturen,
    // anders weigert het schema het en breekt de hele adviesflow (bv. volume 1).
    if (vol !== undefined && vol >= 100 && vol <= 1000000) pond.volume_l = Math.round(vol);
    const airSel = form.elements['has_airpump'];
    if (airSel && airSel.value === 'ja') pond.backup_pump_or_airpump_available = true;
    else if (airSel && airSel.value === 'nee') pond.backup_pump_or_airpump_available = false;
    const uvcSel = form.elements['has_uvc'];
    if (uvcSel && uvcSel.value === 'ja') pond.has_uvc = true;
    else if (uvcSel && uvcSel.value === 'nee') pond.has_uvc = false;
    // B6 (audit 2026-05-24): expert-velden (alleen meesturen indien ingevuld).
    const filterEl = form.elements['filter_type'];
    if (filterEl && filterEl.value) pond.filter_type = filterEl.value;
    const pumpLph = num('pump_lph');
    if (pumpLph !== undefined && pumpLph > 0) pond.pump_throughput_liters_per_hour = Math.round(pumpLph);
    const uvcWatt = num('uvc_watt');
    if (uvcWatt !== undefined && uvcWatt > 0) pond.uvc_watt = Math.round(uvcWatt);
    const lampMonths = num('uvc_lamp_months');
    if (lampMonths !== undefined && lampMonths >= 0) pond.days_since_uv_lamp_replacement = Math.round(lampMonths * 30);
    const fishKg = num('fish_kg');
    if (fishKg !== undefined && fishKg > 0) pond.total_fish_weight_kg = Math.round(fishKg);
    return { measurements, depth_cm, pond, observations };
  }

  async function reverseGeocodeCoords(lat, lon) {
    // Backend-proxy (POST), houdt data-flow EU-only. Fallback: geen postcode, alleen coords.
    try {
      const r = await vwApi.reverseGeocode(lat, lon);
      if (r && r.ok && r.data) return r.data; // verwacht { postcode, lat, lon, plaats, gemeente }
    } catch (_) {}
    return { lat, lon };
  }

  function setGeoStatus(msg, isError) {
    const loc = $('#vw-loc');
    if (loc) {
      loc.textContent = msg;
      loc.className = 'text-sm ' + (isError ? 'text-red-700' : 'text-slate-500') + ' mb-2';
    }
  }

  function init() {
    track('vw_init', { locale: CFG.shopLocale });

    initScrollSpy();

    // Empty-state + sticky-initial CTA: scrolt + focust postcode-veld.
    // Event-delegation zodat dynamisch herrenderde buttons (na innerHTML-reset
    // van #vw-advies-cards) blijven werken. Plus expliciete preventDefault op
    // sticky-anchor zodat we niet op browser-default scroll vertrouwen
    // (was-niet-betrouwbaar mobiel/sticky-nav, fix 2026-05-26).
    document.addEventListener('click', (e) => {
      const t = e.target && e.target.closest && e.target.closest('[data-vw-empty-cta="postcode"], [data-vw-sticky="initial"], [data-vw-edit-location]');
      if (!t) return;
      e.preventDefault();
      const pc = document.getElementById('vw-postcode');
      if (!pc) return;
      const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      // Robuste scroll: expliciete window.scrollTo met getBoundingClientRect,
      // werkt waar scrollIntoView faalt (overflow-clip parents, sticky-nav offset).
      try {
        const rect = pc.getBoundingClientRect();
        const targetY = Math.max(0, window.scrollY + rect.top - 120);
        window.scrollTo({ top: targetY, behavior: reduce ? 'auto' : 'smooth' });
      } catch (_) {
        try { pc.scrollIntoView(); } catch (_) {}
      }
      // Focus nadat de scroll begonnen is, preventScroll voorkomt dat de
      // browser opnieuw probeert te scrollen.
      setTimeout(() => { try { pc.focus({ preventScroll: true }); } catch (_) { pc.focus(); } }, reduce ? 50 : 400);
      try {
        track('vw_empty_cta_click', { target: 'postcode', via: t.matches('[data-vw-sticky="initial"]') ? 'sticky' : (t.matches('[data-vw-edit-location]') ? 'subbar' : 'empty') });
      } catch (_) {}
    });

    $$('a[data-preserve-utm="true"]').forEach(a => {
      a.addEventListener('click', () => {
        a.href = preserveUtm(a.href);
      }, { once: true });
    });

    // ── Hero: postcode-form
    //
    // Persistence-contract (task #52): we onthouden alleen het *getypte* postcode,
    // niet het hele advies of de coords. Reden: postcode is niet-sensitive en
    // valt onder art. 6(1)(f) legitimate interest (UX-comfort); lat/lon +
    // advies zijn rekkelijker data en horen niet in de browser te blijven
    // slingeren. localStorage ipv sessionStorage zodat een terugkerende
    // bezoeker na 2 weken nog steeds zijn postcode ziet staan.
    const PC_KEY = 'vw_postcode_v1';
    const savePostcode = (pc) => {
      try { if (pc) localStorage.setItem(PC_KEY, pc); } catch (_) { /* private mode */ }
    };
    const restorePostcode = () => {
      try { return localStorage.getItem(PC_KEY) || ''; } catch (_) { return ''; }
    };

    // Diagnose-form velden (watertest + diepte) vallen onder dezelfde UX-grond
    // als postcode: niet-sensitive, comfort voor terugkerende bezoekers die
    // wekelijks hun parameters checken. Bump het _v1-suffix als het veldenschema
    // verandert zodat stale storage bij deploy verdwijnt.
    const DIAG_KEY    = 'vw_diagnose_v1';
    const DIAG_FIELDS = ['ph', 'kh', 'gh', 'no2', 'no3', 'nh4', 'o2', 'depth_cm', 'volume_l', 'has_airpump', 'has_uvc', 'alg_type', 'filter_type', 'pump_lph', 'uvc_watt', 'uvc_lamp_months', 'fish_kg'];
    const saveDiagnoseValues = (form) => {
      if (!form) return;
      try {
        const out = {};
        DIAG_FIELDS.forEach(name => {
          const el = form.elements && form.elements[name];
          const v  = el && typeof el.value === 'string' ? el.value.trim() : '';
          if (v) out[name] = v;
        });
        if (Object.keys(out).length) {
          localStorage.setItem(DIAG_KEY, JSON.stringify(out));
        }
      } catch (_) { /* private mode, stil falen */ }
    };
    const restoreDiagnoseValues = (form) => {
      if (!form) return 0;
      let raw = null;
      try { raw = localStorage.getItem(DIAG_KEY); } catch (_) { return 0; }
      if (!raw) return 0;
      let obj;
      try { obj = JSON.parse(raw); } catch (_) { return 0; }
      if (!obj || typeof obj !== 'object') return 0;
      let filled = 0;
      DIAG_FIELDS.forEach(name => {
        const el = form.elements && form.elements[name];
        // Alleen lege velden prefillen, nooit een waarde overschrijven die
        // iemand net aan het typen is.
        if (el && !el.value && typeof obj[name] === 'string' && obj[name]) {
          el.value = obj[name];
          filled++;
        }
      });
      return filled;
    };

    const form = $('#vw-postcode-form');
    if (form) {
      // Prefill op init, als het input-veld nog leeg is én we een eerder
      // bewaarde postcode hebben, zet die terug. NIET auto-submitten:
      // gebruiker beslist zelf wanneer hij een nieuw advies vraagt.
      const pcInputInit = $('#vw-postcode');
      if (pcInputInit && !pcInputInit.value) {
        const saved = restorePostcode();
        if (saved) {
          pcInputInit.value = saved;
          setGeoStatus('Eerder gebruikte postcode ' + saved + ' teruggezet.');
          track('vw_postcode_restored', {});
        }
      }

      // Ook watertest + diepte prefillen (task #81, complement op #52).
      // Zelfde patroon: alleen lege velden vullen, geen auto-submit.
      const diagInit = $('#vw-diagnose-form');
      // Vijverprofiel (24-10-2026, assets/vijvercheck-profiel.js): lege velden uit het profiel en de postcode
      // uit het adres, voor het terugzetten uit deze browser. Zo gaat het profiel voor bij de vijvergegevens;
      // watertestwaarden uit de browser komen daarna gewoon terug. Alleen voor een ingelogde klant.
      let profielGevuld = [];
      try {
        if (window.vwProfiel && typeof window.vwProfiel.vul === 'function') {
          profielGevuld = window.vwProfiel.vul(document, pcInputInit, diagInit, $('#vw-profiel-melding'));
        }
      } catch (_) { profielGevuld = []; }
      if (profielGevuld.length) track('vw_profiel_prefill', { fields_filled: profielGevuld.length, postcode: profielGevuld.indexOf('postcode') !== -1 });
      const diagFilled = restoreDiagnoseValues(diagInit);
      if (diagFilled > 0) track('vw_diagnose_restored', { fields_filled: diagFilled });
      // Diepte Stap 1 <-> Stap 2 gelijk houden (zie vwDepthQuick).
      (function wireDepthQuick() {
        const sel = $('#vw-depth-quick');
        const exact = $('#vw-depth');
        if (!sel) return;
        if (exact && exact.value) vwSyncDepthQuickFrom(parseInt(String(exact.value).replace(/\D/g, ''), 10));
        sel.addEventListener('change', function () {
          const v = vwDepthQuick();
          if (v == null) return;
          if (exact) {
            exact.value = String(v);
            exact.dispatchEvent(new Event('input', { bubbles: true }));
            exact.dispatchEvent(new Event('change', { bubbles: true }));
          }
          try { track('vw_depth_quick_change', { depth_cm: v }); } catch (_) {}
        });
        if (exact) exact.addEventListener('input', function () {
          const v = parseInt(String(exact.value || '').replace(/\D/g, ''), 10);
          if (Number.isFinite(v)) vwSyncDepthQuickFrom(v);
        });
      })();
      // Agent B refactor 2026-05-27: bij genoeg ingevulde velden in storage
      // start de stap-2 details collapsed met "Watertest ingevuld"-label.
      try {
        var _det = document.getElementById('vw-diagnose-details');
        if (_det && diagFilled >= 7) {
          _det.setAttribute('data-vw-filled', 'true');
          _det.open = false;
        }
      } catch (_) {}
      // Clear-knop moet ook filled-state wissen.
      var _diagClear2 = document.getElementById('vw-diagnose-clear');
      if (_diagClear2) {
        _diagClear2.addEventListener('click', function () {
          var _d2 = document.getElementById('vw-diagnose-details');
          if (_d2) _d2.setAttribute('data-vw-filled', 'false');
        });
      }

      // "Wis alle velden": leeg alle watertest-velden EN de bewaarde localStorage-
      // staat (anders komen ze bij refresh terug). UX 2026-05-23.
      const diagClearBtn = $('#vw-diagnose-clear');
      if (diagClearBtn && diagInit) {
        diagClearBtn.addEventListener('click', () => {
          DIAG_FIELDS.forEach(name => {
            const el = diagInit.elements && diagInit.elements[name];
            if (el) el.value = '';
          });
          try { localStorage.removeItem(DIAG_KEY); } catch (_) { /* private mode */ }
          // Audit 2026-05-25: atomair wissen, ook postcode, samenvatting, advies,
          // producten en sticky-state in dezelfde update, geen oude staat zichtbaar.
          try { localStorage.removeItem(PC_KEY); } catch (_) {}
          var pcEl = $('#vw-postcode'); if (pcEl) pcEl.value = '';
          var cardsEl = $('#vw-advies-cards'); if (cardsEl) cardsEl.innerHTML = '';
          var tipsEl = $('#vw-tips'); if (tipsEl) tipsEl.textContent = 'Je krijgt direct de drie belangrijkste tips voor jouw vijver van vandaag.';
          var locEl = $('#vw-loc'); if (locEl) locEl.textContent = 'Vul je postcode in of deel je locatie. Dan laten we zien wat er speelt.';
          ['#vw-crosssell', '#vw-collections'].forEach(function (sel) { var x = $(sel); if (x) x.hidden = true; });
          ['#vw-crosssell-grid', '#vw-collections-grid'].forEach(function (sel) { var g = $(sel); if (g) g.innerHTML = ''; });
          try { document.body.classList.remove('vw-sticky-on'); } catch (_) {}
          vwSetState('start');
          var sbEl = $('#vw-advies-subbar'); if (sbEl) { sbEl.hidden = true; sbEl.classList.add('hidden'); }
          const first = diagInit.elements && diagInit.elements['ph'];
          if (first && first.focus) first.focus();
          try { track('vw_diagnose_cleared', {}); } catch (_) {}
        });
      }

      // B4 (audit 2026-05-24): volume-calculator (l x b x gem. diepte -> liter).
      var calcBtn = $('#vw-calc-volume');
      if (calcBtn) {
        calcBtn.addEventListener('click', function(){
          var pf = function(id){ var el = $('#'+id); var v = el ? parseFloat((el.value||'').replace(',', '.')) : NaN; return Number.isFinite(v) ? v : null; };
          var L = pf('vw-calc-l'), B = pf('vw-calc-b'), D = pf('vw-calc-d');
          var res = $('#vw-calc-result');
          if (L && B && D) {
            var liters = Math.round(L * B * D * 1000);
            var volEl = $('#vw-volume');
            if (volEl) { volEl.value = liters; volEl.dispatchEvent(new Event('input', { bubbles: true })); }
            if (res) res.textContent = 'Geschat: ' + liters.toLocaleString('nl-NL') + ' liter (ingevuld).';
            try { track('vw_volume_calculated', { liters: liters }); } catch (_) {}
          } else if (res) {
            res.textContent = 'Vul lengte, breedte en diepte in meters in.';
          }
        });
      }

      // ── Klantmodi v1 (presentatie): Volledig/Eenvoudig. Client-side, CSS-gedreven;
      //    beinvloedt de DIAGNOSE/urgentie/veiligheid NOOIT, alleen detailniveau. ──
      var MODE_KEY = 'vw_mode_v1';
      var modeResults = $('#vw-advies-cards');
      var modeSwitch = document.querySelector('[data-vw-component="mode-switch"]');
      function applyVwMode(m){
        if (m !== 'eenvoudig' && m !== 'volledig') m = 'volledig';
        if (modeResults) modeResults.setAttribute('data-vw-mode', m);
        // Agent 1 (EENVOUDIG): body-attribute zodat forecast + cross-sell CSS targeten.
        try { document.body.setAttribute('data-vw-advies-mode', m); } catch(_) {}
        document.querySelectorAll('[data-vw-mode-btn]').forEach(function(b){
          var on = b.getAttribute('data-vw-mode-btn') === m;
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          b.classList.toggle('bg-aqua', on); b.classList.toggle('text-white', on);
          b.classList.toggle('bg-white', !on); b.classList.toggle('text-navy', !on);
        });
      }
      // Agent 1 (EENVOUDIG) 2026-05-27: ALTIJD 'eenvoudig' als default voor nieuwe
      // bezoekers (Bregje overweldigd door tekst). Saved waarde respecteren — toggle
      // blijft beschikbaar voor klanten die expliciet 'Uitgebreid' kiezen.
      var vwMode = 'eenvoudig';
      try {
        var _saved = localStorage.getItem(MODE_KEY);
        if (_saved === 'eenvoudig' || _saved === 'volledig') {
          vwMode = _saved;
        } else {
          vwMode = 'eenvoudig';
        }
      } catch (_) { vwMode = 'eenvoudig'; }
      applyVwMode(vwMode);
      document.querySelectorAll('[data-vw-mode-btn]').forEach(function(b){
        b.addEventListener('click', function(){
          var m = b.getAttribute('data-vw-mode-btn');
          try { localStorage.setItem(MODE_KEY, m); } catch (_) {}
          applyVwMode(m);
          try { track('vw_mode_change', { mode: m }); } catch (_) {}
        });
      });
      // Toon de weergave-switch zodra er advies gerenderd is.
      if (modeResults && modeSwitch && ('MutationObserver' in window)) {
        new MutationObserver(function(){
          modeSwitch.hidden = modeResults.querySelectorAll('.vw-card').length === 0;
        }).observe(modeResults, { childList: true });
      }

      form.addEventListener('submit', async ev => {
        ev.preventDefault();
        // Verbetercyclus run 7 (28-07-2026): postcode normaliseren naar hoofdletters.
        // De backend van /advice weigert 1234ab met 400 VALIDATION_ERROR, terwijl de
        // regex hieronder [A-Za-z] wel doorliet. Bezoekers die hun postcode in kleine
        // letters typten kregen daardoor de rode melding "Fout bij het ophalen van
        // advies" (4 sessies in 7 dagen, alle vier met kleine of gemengde letters).
        const postcode = (form.postcode && form.postcode.value || '')
          .replace(/\s+/g, ' ').trim().toUpperCase();
        if (form.postcode && form.postcode.value !== postcode) form.postcode.value = postcode;
        if (!postcode) {
          setGeoStatus('Vul een geldige postcode in: NL (1234 AB) of BE (1234).', true);
          return;
        }
        // NL: 4 cijfers + 2 letters. BE: 4 cijfers (1000-9992). Alle andere
        // formaten worden geweigerd, backend valideert hetzelfde patroon.
        if (!/^[1-9]\d{3}\s?([A-Za-z]{2})?$/.test(postcode.replace(/\s+/g, ' ').trim())) {
          setGeoStatus('Dit lijkt geen geldige postcode. Formaat: 1234 AB (NL) of 1234 (BE).', true);
          return;
        }
        // Bewaar pas na passing van de regex, we willen geen junk in storage.
        savePostcode(postcode);
        // Pak evt. waarden uit diagnose-form zodat "Advies" knop meteen measurements meeneemt
        const diag = $('#vw-diagnose-form');
        const diagVals = diag ? readDiagnoseValues(diag) : { measurements: {}, depth_cm: undefined };
        // Persist watertest + diepte (task #81). Doen we vóór runAdvice zodat
        // ook als de netwerkcall hapert, wat de bezoeker typte bewaard blijft.
        saveDiagnoseValues(diag);
        const ctx = {
          location: { postcode },
          pond: Object.assign({ depth_cm: diagVals.depth_cm || vwDepthQuick() || 100 }, diagVals.pond || {})
        };
        if (Object.keys(diagVals.measurements).length) ctx.measurements = diagVals.measurements;
        if (diagVals.observations && Object.keys(diagVals.observations).length) ctx.observations = diagVals.observations;
        await runAdvice(ctx);
        scrollToAdvies();
      });
    }

    // ── Hero: geolocation-knop
    const geoBtn = $('#vw-geo');
    if (geoBtn) {
      geoBtn.addEventListener('click', async () => {
        if (!navigator.geolocation) {
          setGeoStatus('Geolocatie niet beschikbaar in deze browser. Vul postcode handmatig in.', true);
          return;
        }
        setGeoStatus('Locatie ophalen…');
        track('vw_geo_requested', {});
        navigator.geolocation.getCurrentPosition(
          async pos => {
            const { latitude: lat, longitude: lon } = pos.coords;
            // Ruwe NL+BE-bounding-box check (Nederland 50.75-53.55°N / 3.2-7.3°E
            // + België 49.45-51.55°N / 2.5-6.45°E). Unie: 49.4-53.6°N / 2.4-7.4°E.
            // Buiten deze unie → zeer waarschijnlijk DE/LU/FR → geen support.
            const inCoverage = lat >= 49.4 && lat <= 53.6 && lon >= 2.4 && lon <= 7.4;
            if (!inCoverage) {
              setGeoStatus('Je locatie lijkt buiten Nederland of België te liggen. VijverCheck ondersteunt momenteel alleen NL- en BE-postcodes.', true);
              track('vw_geo_outside_coverage', { lat_rounded: Math.round(lat), lon_rounded: Math.round(lon) });
              return;
            }
            setGeoStatus('Postcode bepalen…');
            const geo = await reverseGeocodeCoords(lat, lon);
            const pcInput = $('#vw-postcode');
            if (geo && geo.postcode && pcInput) {
              pcInput.value = geo.postcode;
              savePostcode(geo.postcode);  // task #52, ook bij geo-flow persisteren
              setGeoStatus('Postcode ' + geo.postcode + ' gevonden.');
              track('vw_geo_ok', { method: 'reverse-postcode' });
              // Trigger submit
              if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
            } else {
              // Fallback: direct lat/lon → advice zonder postcode
              setGeoStatus('Advies ophalen op basis van coördinaten…');
              track('vw_geo_ok', { method: 'coords-only' });
              const diag = $('#vw-diagnose-form');
              const diagVals = diag ? readDiagnoseValues(diag) : { measurements: {}, depth_cm: undefined };
              saveDiagnoseValues(diag);  // task #81, ook in coords-only flow
              const ctx = {
                location: { lat, lon },
                pond: Object.assign({ depth_cm: diagVals.depth_cm || vwDepthQuick() || 100 }, diagVals.pond || {})
              };
              if (Object.keys(diagVals.measurements).length) ctx.measurements = diagVals.measurements;
        if (diagVals.observations && Object.keys(diagVals.observations).length) ctx.observations = diagVals.observations;
              await runAdvice(ctx);
            }
          },
          err => {
            track('vw_geo_error', { code: err.code });
            const msg = err.code === 1
              ? 'Locatie geweigerd. Vul postcode handmatig in.'
              : 'Locatie niet beschikbaar. Vul postcode handmatig in.';
            setGeoStatus(msg, true);
          },
          { enableHighAccuracy: false, timeout: 15000, maximumAge: 600000 }  // run 9 (11-08-2026): 3 van de 8 geo-pogingen liepen af op precies 8 s; een sessie kreeg na een timeout binnen 2,4 s alsnog een fix, dus de positie was er wel en de limiet was te krap. Ruimere maximumAge hergebruikt een recente fix in plaats van opnieuw te meten.
        );
      });
    }

    // ── Diagnose-form (watertest)
    const diag = $('#vw-diagnose-form');
    if (diag) {
      diag.addEventListener('submit', async ev => {
        ev.preventDefault();
        const pc = ($('#vw-postcode') && $('#vw-postcode').value || '').trim();
        if (!pc) {
          setGeoStatus('Vul eerst je postcode in bovenaan, dan herberekenen we met de watertest.', true);
          const pcInput = $('#vw-postcode');
          if (pcInput && pcInput.focus) pcInput.focus();
          return;
        }
        if (!/^[1-9]\d{3}\s?([A-Za-z]{2})?$/.test(pc.replace(/\s+/g, ' ').trim())) {
          setGeoStatus('Dit lijkt geen geldige postcode. Formaat: 1234 AB (NL) of 1234 (BE).', true);
          return;
        }
        // Baymard-audit 2026-05-25: veld-validatie vóór de API-call. Toont de
        // native foutmelding bij het exacte veld (bv. "≤ 14") i.p.v. een stille 400.
        if (diag && typeof diag.reportValidity === 'function' && !diag.reportValidity()) {
          return;
        }
        const { measurements, depth_cm, pond: pondExtra, observations: obsExtra } = readDiagnoseValues(diag);
        // Persist watertest + diepte (task #81). Gebeurt vóór runAdvice zodat
        // wat de bezoeker invulde ook bewaard blijft als de call faalt.
        saveDiagnoseValues(diag);
        track('vw_diagnose_submitted', {
          fields_filled: Object.keys(measurements).length,
          has_depth: typeof depth_cm === 'number'
        });
        const ctx = {
          location: { postcode: pc },
          pond: Object.assign({ depth_cm: depth_cm || vwDepthQuick() || 100 }, pondExtra || {})
        };
        if (Object.keys(measurements).length) ctx.measurements = measurements;
        if (obsExtra && Object.keys(obsExtra).length) ctx.observations = obsExtra;
        await runAdvice(ctx);
        // Agent B refactor 2026-05-27: watertest stap-2 collapseert ná invullen.
        try {
          var _det = document.getElementById('vw-diagnose-details');
          if (_det) {
            var _fieldCount = Object.keys(measurements || {}).length + (typeof depth_cm === 'number' ? 1 : 0);
            if (_fieldCount >= 7) {
              _det.setAttribute('data-vw-filled', 'true');
              _det.open = false;
            } else if (_fieldCount >= 3) {
              // Deels ingevuld: markeren maar laten open zodat klant kan aanvullen.
              _det.setAttribute('data-vw-filled', 'partial');
            }
          }
        } catch (_) {}
        scrollToAdvies();
      });

      // ── Auto-refresh forecast bij diepte-invoer (v1.2c)
      //    Zodra gebruiker een geldige diepte intikt EN we hebben al een
      //    geocoded lat/lon (uit eerdere /advice-call), herberekenen we
      //    alleen de forecast, geen volledige /advice-roundtrip.
      const depthInput = $('#vw-depth');
      if (depthInput) {
        let depthDebounce = null;
        const refetchForecast = async () => {
          const raw = (depthInput.value || '').trim();
          const depth = raw ? parseInt(raw, 10) : NaN;
          if (!Number.isFinite(depth) || depth < 20 || depth > 400) return;
          if (forecastState.lat == null || forecastState.lon == null) return;
          if (forecastState.lastDepthCm === depth) return; // no-op
          track('vw_forecast_depth_refetch', { depth_cm: depth });
          try {
            const fr = await vwApi.forecast(forecastState.lat, forecastState.lon, 7, depth);
            if (fr && fr.ok && fr.data) {
              renderForecast({ data: fr.data });
            }
          } catch (_) { /* stil falen, widget blijft op laatste render */ }
        };
        depthInput.addEventListener('change', refetchForecast);
        depthInput.addEventListener('input', () => {
          if (depthDebounce) clearTimeout(depthDebounce);
          depthDebounce = setTimeout(refetchForecast, 600);
        });
      }
    }

    // ── Subscribe-form (Klaviyo opt-in)
    const sub = $('#vw-subscribe-form');
    if (sub) {
      sub.addEventListener('submit', async ev => {
        ev.preventDefault();
        const status = $('#vw-subscribe-status');
        const setStatus = (msg, tone) => {
          if (!status) return;
          const colors = { ok: 'text-green-700', err: 'text-red-700', info: 'text-slate-500' };
          status.className = 'text-xs mt-2 min-h-[1.2em] ' + (colors[tone] || colors.info);
          status.textContent = msg;
        };

        const email = (sub.email && sub.email.value || '').trim();
        const consentEl = sub.elements['consent'];
        const consentOk = consentEl && consentEl.checked;

        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          setStatus('Vul een geldig e-mailadres in.', 'err');
          return;
        }
        if (!consentOk) {
          setStatus('Vink de consent-checkbox aan om je aan te melden.', 'err');
          return;
        }

        // Knop bevat SVG + label-tekst; textContent-swap zou SVG wissen.
        // Gebruik innerHTML-snapshot zodat de mail-icon blijft staan na restore.
        const btn = sub.querySelector('button[type="submit"]');
        if (btn) { btn.disabled = true; btn.dataset.origHtml = btn.innerHTML; btn.textContent = 'Bezig…'; }
        setStatus('Aanmelden…', 'info');

        const pc = ($('#vw-postcode') && $('#vw-postcode').value || '').trim();
        const res = await onSubscribe(email, pc ? { postcode: pc } : {});

        if (btn) { btn.disabled = false; btn.innerHTML = btn.dataset.origHtml || 'Aanmelden'; }

        if (res && (res.ok || res.status === 202)) {
          setStatus('Gelukt! Je ontvangt zo een bevestigingsmail.', 'ok');
          trackConversion('subscribe', 0);
          sub.reset();
        } else {
          const code = res && res.errors && res.errors[0] && res.errors[0].code;
          setStatus(code === 'RATE_LIMIT'
            ? 'Te veel pogingen. Probeer het over een paar minuten opnieuw.'
            : 'Aanmelding mislukt. Probeer het later opnieuw of mail service@vijvercentrum.nl.', 'err');
        }
      });
    }

    if (CFG.enableSelfTests) {
      console.group('[VijverCheck] Self-tests');
      console.log('CFG:', CFG);
      console.log('sessionId:', getOrCreateSessionId());
      vwApi.rules().then(r => console.log('rules-count:', (r.data || []).length));
      console.groupEnd();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ──────────────────────────────────────────────────────────────
  // EXPOSE
  // ──────────────────────────────────────────────────────────────
  window.VijverCheck = {
    version: '0.2.0-thinclient',
    config: CFG,
    api: vwApi,
    track, trackConversion, runAdvice, onSubscribe, preserveUtm, hasAnalyticsConsent, flushEvents,
    renderAdviceCards, renderAdviceSummary, renderForecast, renderCrossSell,
    renderCollectionLinks,
    // Exposed helpers voor self-tests + Chrome-DOM assertions
    humanizeTrigger, humanizeCollection, productHandle, uniqueProducts,
    TRIGGER_LABELS, COLLECTION_LABELS,
    severityFromUrgency, applyBrandVoiceTic, copyStartsWithTic,
    URGENCY_TO_SEVERITY, TICS_BY_SEVERITY
  };

  // ── D (5-agent UX 2026-05-26): Live stepper init ──────────────────
  (function vwStepperInit(){
    var stepper = document.getElementById('vw-stepper');
    if (!stepper) return;
    var PC_RE = /^[1-9]\d{3}\s?([A-Za-z]{2})?$/;
    var DIAG_FIELDS = ['ph','kh','gh','no2','no3','nh4','o2'];
    var PROFILE_FIELDS = ['depth_cm','volume_l','has_airpump','has_uvc','alg_type','filter_type','pump_lph','uvc_watt','uvc_lamp_months','fish_kg'];
    function hasPostcode(){
      try {
        var v = (localStorage.getItem('vw_postcode_v1') || '').trim();
        return PC_RE.test(v.replace(/\s+/g,' ').trim());
      } catch(_) { return false; }
    }
    function hasDiagnose(){
      try {
        var raw = localStorage.getItem('vw_diagnose_v1');
        if (!raw) return false;
        var d = JSON.parse(raw) || {};
        var m = d.measurements || {};
        var p = d.pond || {};
        for (var i=0;i<DIAG_FIELDS.length;i++){
          if (m[DIAG_FIELDS[i]] != null && m[DIAG_FIELDS[i]] !== '') return true;
        }
        for (var j=0;j<PROFILE_FIELDS.length;j++){
          var k = PROFILE_FIELDS[j];
          if (d[k] != null && d[k] !== '') return true;
          if (p[k] != null && p[k] !== '') return true;
        }
        return false;
      } catch(_) { return false; }
    }
    function hasAdvies(){
      var cards = document.getElementById('vw-advies-cards');
      if (!cards) return false;
      return cards.querySelectorAll('.vw-card, [data-vw-card]').length > 0;
    }
    function setStep(li, state){
      li.setAttribute('data-vw-state', state);
      if (state === 'current') li.setAttribute('aria-current','step');
      else li.removeAttribute('aria-current');
    }
    function refresh(){
      var s1 = hasPostcode(), s2 = hasDiagnose(), s3 = hasAdvies();
      var items = stepper.querySelectorAll('[data-vw-step]');
      var states = [
        s1 ? 'done' : 'current',
        s2 ? 'done' : (s1 ? 'current' : 'todo'),
        s3 ? 'done' : ((s1 && s2) ? 'current' : 'todo')
      ];
      items.forEach(function(li, i){ setStep(li, states[i]); });
    }
    refresh();
    document.addEventListener('submit', function(e){
      if (e.target && (e.target.id === 'vw-postcode-form' || e.target.id === 'vw-diagnose-form')) {
        setTimeout(refresh, 30);
      }
    }, true);
    var cards = document.getElementById('vw-advies-cards');
    if (cards && 'MutationObserver' in window) {
      new MutationObserver(refresh).observe(cards, { childList: true });
    }
    window.addEventListener('storage', function(e){
      if (e.key === 'vw_postcode_v1' || e.key === 'vw_diagnose_v1') refresh();
    });
  })();

  // ── F (5-agent UX 2026-05-26): ESC sluit alle open tooltips ───────
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details.vw-tip[open]').forEach(function(d){ d.open = false; });
  });

})();

;(function(){ try { if (typeof track === 'function' && !window.vwTrack) window.vwTrack = track; } catch(_){} })(); // vw-expose-track
